import React, { useState, useEffect, useRef } from 'react';
import { handleServiceSelection } from '../../../../utils/serviceSelectionUtils';
import { setCurrentContext } from '../../../../utils/fieldStructureUtils';
import { CONTEXT_TYPES } from '../../../../utils/fieldContextUtils';
import { handleEmployeeSelection as processEmployeeSelection } from '../../../../utils/employeeContextUtils';
import { FieldStructureProvider, useFieldStructure } from '../../../../contexts/FieldStructureContext';
import { Grid, Select, MenuItem, TextField, InputLabel, FormControl, Box, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Button, Typography, Avatar, Divider, Chip, Switch, FormControlLabel, Tooltip } from "@mui/material";
import {
  Person as PersonIcon,
  AccessTime as AccessTimeIcon,
} from "@mui/icons-material";
import WDBox from "../../../../MaterialComponents/WDBox";
import WDButton from "../../../../MaterialComponents/WDButton";
import WDTypography from "../../../../MaterialComponents/WDTypography";
import AppService from "../../../../Configurations/Appservice";
import apiService from "../../../../services/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import AuthenticatedImage from '../../../../Components/AuthenticatedImage';
import { object, string } from "yup";
import * as Yup from 'yup';
import { API_PATHS } from '../../../../utils/constants';
import { getAuthToken } from '../../../../utils/authUtils';

import FileField from "./panels/FileField";
import FieldText from "./panels/FieldText";
// useDispatch already imported above
import {
  showLoader,
  dismissLoader,
  showSuccessMessage,
  showErroMessage,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { updateScreenTitle } from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import { STAT_FIELDS, MEDICAL_LOCATIONS, DOCUMENT_TYPE_MAPPING } from "../../../../Configurations/StatFieldData";
import CustomerTextField from "./panels/CustomerStatFieldInfo";
import { MdPersonSearch, MdPerson } from "react-icons/md";
import pxToRem from "../../../../Themes/Functions/pxToRem";

import LayoutCard from "../../../../Components/LayoutCard";
// Import the new styles for modern card-based design
import { headerStyle, cardStyle, cardContentStyle, stickyFooterStyle, secondaryHeaderStyle, secondaryCardStyle } from "./styles";
// Import CategorizedFields component directly to avoid circular dependencies
import CategorizedFields from "../../../../Components/WorkflowFields/CategorizedFields";
import * as fieldCategoryUtils from "../../../../utils/fieldCategoryUtils";
import QuickEmployeeSearch from "../../../../Components/EmployeeSearch/QuickEmployeeSearch";
import { getStaticDocumentFields, STATIC_FIELD_CATEGORY_MAP } from '../../../../utils/fieldCategoryMapping';
import QuickEmployeeAddDialog from "../../../../Components/QuickEmployeeAdd/QuickEmployeeAddDialog";
import { ServiceSelectionPanel } from "../../../../Components/ServiceSelection";
import WdDivider from "../../../../Components/WdDivider";
import StepProgress from "../../../../Components/StepProgress";

dayjs.extend(utc);

const initialValues = {
  description: "",
  serviceId: "",
  employeeId: "", // Added for employee assignment
  assignedTo: "THAKLIS",

  uid: "",
  firstNameEn: "",
  middleNameEn: "",
  lastNameEn: "",
  firstNameAr: "",
  middleNameAr: "",
  lastNameAr: "",
  nameEn: "",
  nameAr: "",
  dob: null,
  gender: "",
  nationality: "",
  passportNumber: "",
  passportIssue: "",
  passportExpiry: null,
  passportExpiry2: null,
  passportIssuePlaceEn: "",
  passportIssuePlaceAr: "",
  emiratesId: "",
  emirates_id_number: "",
  emiratesIdIssueDate: null,
  emiratesIdExpiryDate: null,
  emirates_id_expiry_date: null,
  birthPlaceEn: "",
  birthPlaceAr: "",
  birthCertificate: "",
  emirate: "",
  medicalLocation: "",
  address: "",
  area: "",
  buildingNumber: "",
  poBox: "",
  mobileNumber: "",
  landNumber: "",
  deliveryNumber: "",
  email: "",
  fileNumber: "",
  passportCopy: "",
  visaPage: "",
  visaIssueDate: null,
  visaExpiryDate: null,
  photo: "",
  shinasnama: "",
  labourContract: "",
  salaryCertificate: "",
};

const validationSchema = object({
  serviceId: string().required("Service is Mandatory"),
});

const NewTicket = () => {
  // Access field structure context
  const fieldStructureContext = useFieldStructure();
  
  // Destructure methods from context
  const {
    initializeStructure,
    processServiceResponse,
    updateContext,
    shouldShowFieldInSection
  } = fieldStructureContext;

  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [serviceGroups, setServiceGroups] = useState([]);
  const [fields, setFields] = useState([]);
  const [chargeMapping, setChargeMapping] = useState();
  const [ticketAssignedTo, setTicketAssignedTo] = useState("THAKLIS");
  const [canTicketSelfAssign, setCanTicketSelfAssign] = useState(false);
  const [uploadingStaticDocs, setUploadingStaticDocs] = useState([]);
  const [documentRequired, setDocumentRequired] = useState([]);
  const [additionalInfoRequired, setAdditionalInfoRequired] = useState([]);
  const [populatedFields, setPopulatedFields] = useState(new Set());
  const [processedDocumentFields, setProcessedDocumentFields] = useState(new Map());
  const formikRef = useRef();

  // Initialize medicalLocation in Formik when it appears in the fields list
  useEffect(() => {
    const hasMedicalLocation = fields.some(f => f.name === "medicalLocation");
    if (hasMedicalLocation && formikRef.current && !formikRef.current.values?.medicalLocation) {
      formikRef.current.setFieldValue("medicalLocation", MEDICAL_LOCATIONS[0]);
    }
  }, [fields]);

  const organizationName = localStorage.getItem("organization_name") || "Your Organization";

  const [isUidready, uidReady] = useState(false);
  
  // Helper function to track processed document fields
  const trackDocumentField = (fieldName, documentUrl) => {
    setProcessedDocumentFields(prev => {
      const updated = new Map(prev);
      updated.set(documentUrl || fieldName, fieldName);
      return updated;
    });
    console.log(`Tracked document field: ${fieldName} with URL: ${documentUrl || 'no URL'}`);
  };

  // Helper function to check if a document field has been processed
  const isDocumentFieldProcessed = (fieldName, documentUrl) => {
    return processedDocumentFields.has(documentUrl || fieldName);
  };
  
  // Helper function to determine if a field is a document field
  const isDocumentField = (field) => {
    if (!field) return false;
    
    // Check if field is explicitly marked as a document type
    if (field.type === 'DOCUMENT' || field.type === 'FILE') {
      return true;
    }
    
    // First, check STAT_FIELDS configuration for proper field type
    if (field.name && STAT_FIELDS[field.name]) {
      const statFieldConfig = STAT_FIELDS[field.name];
      return statFieldConfig.type === 'FILE';
    }
    
    // Check known document field names (excluding emiratesId which is now TEXT)
    const documentFieldNames = [
      'passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 
      'labourContract', 'photo', 'shinasnama'
    ];
    
    if (field.name && documentFieldNames.includes(field.name)) {
      return true;
    }
    
    // Check if field name contains document-related keywords (but exclude 'id' to avoid emiratesId)
    const documentKeywords = ['file', 'document', 'certificate', 'upload', 'photo', 
                             'signature', 'copy', 'scan', 'passport'];
    
    if (field.name && documentKeywords.some(keyword => 
      field.name.toLowerCase().includes(keyword))) {
      return true;
    }
    
    return false;
  };
  
  // Function to ensure consistent field categorization
  const ensureConsistentFieldCategorization = (fields) => {
    if (!fields || !Array.isArray(fields)) return fields;
    
    return fields.map(field => {
      // Create a copy of the field to avoid mutating the original
      const updatedField = { ...field };
      
      // Check if this is a document field
      if (isDocumentField(field)) {
        // Force document fields to be consistently typed and categorized
        updatedField.type = 'DOCUMENT';
        updatedField.category = 'DOCUMENTS';
        
        // Log the categorization change if it was different
        if (field.category !== 'DOCUMENTS' || field.type !== 'DOCUMENT') {
          console.log(`Ensuring consistent categorization for document field ${field.name}: `, {
            before: { type: field.type, category: field.category },
            after: { type: 'DOCUMENT', category: 'DOCUMENTS' }
          });
        }

      // Note: profile autofill is handled in autoPopulateFromBackend after grouped docs are processed
      }
      
      return updatedField;
    });
  };

  const [staticFields, setStaticFields] = useState([]);
  const [uid, setUid] = useState("");
  
  // State to store field categories
  const [fieldCategories, setFieldCategories] = useState([]);
  
  // State for employee selection
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  
  // Quick add employee dialog state
  const [openQuickAddEmployee, setOpenQuickAddEmployee] = useState(false);
  
  // Customer creation dialog state
  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    uid: "",
    firstNameEn: "",
    middleNameEn: "",
    lastNameEn: "",
    nameEn: "",
    mobileNumber: "",
    email: ""
  });

  const [file, setFile] = useState();
  const dispatch = useDispatch();
  
  // Removed preview dialog state (direct submit enabled)
  
  // Handle document field auto-filling from employee documents
  const handleDocumentFieldAutoFill = async (fieldName, employee, field = null) => {
    console.log(`Attempting to auto-fill document field: ${fieldName} for employee:`, {
      employeeId: employee.id,
      employeeUid: employee.uid,
      timestamp: new Date().toISOString()
    });
    // If already populated (e.g., via grouped API), do not override
    try {
      const existing = formikRef?.current?.values?.[fieldName];
      if (existing && (typeof existing !== 'object' || existing.filePath || existing.documentReferences || existing.isReference)) {
        console.log(`Skipping handleDocumentFieldAutoFill for ${fieldName} - already has value from grouped API or existing state`);
        return true;
      }
    } catch (e) {
      // ignore and continue
    }
    
    // First check if employee has documents in the employee object
    const hasLocalDocuments = employee.documents && employee.documents.length > 0;
    
    if (hasLocalDocuments) {
      console.log('Found documents in employee data:', employee.documents.length);
    }
    
    let matchingDoc = null;
    
    // Check if employee has documents array
    if (employee.documents && Array.isArray(employee.documents)) {
      console.log(`Employee has ${employee.documents.length} documents, checking for ${fieldName}`);
      
      // Try to find a document that matches this field name
      matchingDoc = employee.documents.find(doc => 
        doc.documentType && doc.documentType.toLowerCase() === fieldName.toLowerCase()
      );
    }
    
    // If no matching document found in the documents array, try to fetch it
    if (!matchingDoc) {
      try {
        console.log(`No matching document found in employee data, trying to fetch from API for ${fieldName}`);
        
        // Get auth token from local storage
        const token = localStorage.getItem('token') || 
                    localStorage.getItem('jwt_token') || 
                    localStorage.getItem('authToken');
        
        if (!token) {
          console.error('Authentication token not found');
          return false;
        }
        
        // Get the base URL from environment or current origin
        const apiBaseUrl = process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}:8080`;
        
        // Try to fetch documents for this employee
        const response = await fetch(`${apiBaseUrl}/v1/users/${employee.uid}/documents`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const documents = await response.json();
          console.log(`Fetched ${documents.length} documents for employee ${employee.uid}`);
          
          // Try to find a document that matches this field name
          matchingDoc = documents.find(doc => 
            doc.documentType && doc.documentType.toLowerCase() === fieldName.toLowerCase()
          );
        } else {
          console.error(`Failed to fetch documents: ${response.status}`);
        }
      } catch (error) {
        console.error('Error fetching employee documents:', error);
      }
    }
    
    if (matchingDoc) {
      console.log(`Found matching document for ${fieldName}:`, matchingDoc);
      
      // Check if this is a dynamic service field (UUID pattern)
      const isDynamicServiceField = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(matchingDoc.documentType);
      
      // Create a document reference object with necessary metadata
      const documentReference = {
        isReference: true,                // Flag to indicate this is a reference to an existing document
        id: matchingDoc.id || matchingDoc.filePath, // Document ID for backend association
        uid: matchingDoc.uid || employee.uid,
        documentType: matchingDoc.documentType, // Keep the original document type from the backend
        fileName: matchingDoc.fileName || `${fieldName} Document`,
        contentType: matchingDoc.contentType || 'application/pdf',
        fileSize: matchingDoc.fileSize || 0,
        // Source employee UID - critical for document viewing
        employeeUid: employee.uid,
        filePath: matchingDoc.filePath || matchingDoc.id,
        // Add document URL for tracking - but only for static fields
        documentUrl: isDynamicServiceField ? 
          (matchingDoc.filePath ? `/v1/files/download?filePath=${encodeURIComponent(matchingDoc.filePath)}` : null) :
          `/v1/users/${employee.uid}/documents/${matchingDoc.documentType}/download`
      };
      
      // Track this document field to prevent duplication
      trackDocumentField(fieldName, documentReference.documentUrl || documentReference.filePath);
      
      // Log the created document reference for debugging
      console.log('Created document reference:', documentReference);
      
      // Set the field value in the form
      formikRef.current.setFieldValue(fieldName, documentReference);
      
      // Special handling for visa document to extract and set visa dates
      if (fieldName === 'visaPage' && matchingDoc.extractedData) {
        console.log('Processing visa document extracted data:', matchingDoc.extractedData);
        
        // Check for visa issue date in extracted data (try both visaIssueDate and issueDate)
        const issueDate = matchingDoc.extractedData.visaIssueDate || matchingDoc.extractedData.issueDate;
        if (issueDate) {
          const visaIssueDate = new Date(issueDate);
          if (!isNaN(visaIssueDate.getTime())) {
            console.log('Setting visa issue date:', visaIssueDate, '(from field:', issueDate === matchingDoc.extractedData.visaIssueDate ? 'visaIssueDate' : 'issueDate', ')');
            formikRef.current.setFieldValue('visaIssueDate', visaIssueDate);
            setPopulatedFields(prev => new Set([...prev, 'visaIssueDate']));
          }
        } else {
          console.log('No visa issue date found in extracted data. Available fields:', Object.keys(matchingDoc.extractedData).join(', '));
        }
        
        // Check for visa expiry date in extracted data (try both visaExpiryDate and expiryDate)
        const expiryDate = matchingDoc.extractedData.visaExpiryDate || matchingDoc.extractedData.expiryDate;
        if (expiryDate) {
          const visaExpiryDate = new Date(expiryDate);
          if (!isNaN(visaExpiryDate.getTime())) {
            console.log('Setting visa expiry date:', visaExpiryDate, '(from field:', expiryDate === matchingDoc.extractedData.visaExpiryDate ? 'visaExpiryDate' : 'expiryDate', ')');
            formikRef.current.setFieldValue('visaExpiryDate', visaExpiryDate);
            setPopulatedFields(prev => new Set([...prev, 'visaExpiryDate']));
          }
        } else {
          console.log('No visa expiry date found in extracted data. Available fields:', Object.keys(matchingDoc.extractedData).join(', '));
        }
      }
      
      // Mark this field as populated
      setPopulatedFields(prev => new Set([...prev, fieldName]));
      
      // Update the field in our state if field object was provided
      if (field) {
        setFields(prevFields => prevFields.map(f => {
          if (f.name === fieldName) {
            // Make sure the field is marked as a document type
            return { 
              ...f, 
              value: documentReference,
              type: 'DOCUMENT',  // Force consistent type
              category: 'documents' // Force consistent category
            };
          }
          return f;
        }));
      }
      
      console.log(`Auto-filled document field ${fieldName} with document reference:`, documentReference);
      return true; // Document was auto-filled
    } else {
      console.log(`No matching document found for field ${fieldName}`);
      return false; // No matching document found
    }
  };

  // Handle employee removal - reset employee-related state
  const handleEmployeeRemove = () => {
    console.log('Removing employee selection');
    
    // Reset employee-related state
    setSelectedEmployee(null);
    setUid('');
    window.currentEmployeeUid = null;
    
    // Reset form fields related to employee
    if (formikRef && formikRef.current) {
      formikRef.current.setFieldValue('employeeId', '');
      formikRef.current.setFieldValue('employeeUid', '');
    }
    
    // Update context back to default
    updateContext(CONTEXT_TYPES.DEFAULT);
    
    // Clear any populated fields
    setPopulatedFields(new Set());
  };
  
  // Handle newly created employee from quick add dialog
  const handleEmployeeAdded = (newEmployee) => {
    console.log('New employee created:', newEmployee);
    
    // Close the dialog
    setOpenQuickAddEmployee(false);
    
    // Select the newly created employee
    if (newEmployee) {
      handleEmployeeSelect(newEmployee);
    }
  };
  
  // Check if form values contain any file uploads
  const hasFileUploads = (values) => {
    // If no values, no file uploads
    if (!values) return false;
    
    // Check fields for file uploads
    if (fields && fields.length > 0) {
      for (const field of fields) {
        // Check if this is a file field with a value
        if (field.type === 'file' && values[field.name] && 
            (values[field.name].s3Key || values[field.name].downloadUrl || 
             values[field.name].filePath || values[field.name].fileName)) {
          return true;
        }
      }
    }
    
    return false;
  };
  
  // Handle employee selection and auto-fill static fields
  const handleEmployeeSelect = async (employee) => {
    console.log('Employee selected:', employee);
    
    if (!employee) {
      handleEmployeeRemove();
      return;
    }
    
    console.log('Full employee data:', JSON.stringify(employee));
      
    // Update the newCustomer state with the employee's data
    // Since the field names already match, we can use them directly
    setNewCustomer(prevState => ({
      ...prevState,
      mobileNumber: employee.mobileNumber || prevState.mobileNumber,
      firstNameEn: employee.firstNameEn || prevState.firstNameEn,
      middleNameEn: employee.middleNameEn || prevState.middleNameEn,
      lastNameEn: employee.lastNameEn || prevState.lastNameEn,
      email: employee.email || prevState.email
    }));
    
    // Set global variable for employee UID to ensure it's available for file uploads
    window.currentEmployeeUid = employee.uid;
    console.log(`%cSetting global employeeUid for file uploads:`, 'color: blue; font-weight: bold', employee.uid);
    
    // Update the field structure context to EMPLOYEE context
    updateContext(CONTEXT_TYPES.EMPLOYEE);
    
    // Auto-fill document fields if available
    if (employee.documents && Array.isArray(employee.documents)) {
      console.log(`Employee has ${employee.documents.length} documents, attempting to auto-fill`);
    }
      
    // Source the customer organisation id from the logged-in principal so
    // processEmployeeSelection can autofill the 'address' field from the
    // org (not from employee.address). Helper tolerates null gracefully.
    let customerOrgId = null;
    try {
      const authInfo = JSON.parse(localStorage.getItem('authInfo') || '{}');
      customerOrgId = authInfo?.principalInfo?.organisationId || null;
    } catch (_) { /* ignore */ }

    // Use our new employee context utility to handle selection and field structure updates
    const updatedStructure = processEmployeeSelection(
      employee,
      formikRef, // Pass the formik reference as formRef parameter
      setFields,
      setUid,
      uidReady,
      setPopulatedFields,
      setSelectedEmployee,
      dispatch,
      customerOrgId
    );
    
    if (updatedStructure) {
      console.log('Field structure updated for employee context:', updatedStructure);
      
      // Show success message
      dispatch(showSuccessMessage("Employee selected and field structure updated successfully"));
      
      // Call backend auto-population API for employee documents and capture fields populated
      const populatedFromGrouped = await autoPopulateFromBackend(employee.uid);
      
      // Auto-fill static fields based on employee data
      if (fields && fields.length > 0) {
        console.log('Auto-filling fields from employee data');
        
        // Get the list of static fields we want to auto-fill. 'address' is
        // intentionally NOT here — it's auto-filled from the customer
        // organisation's address inside processEmployeeSelection above,
        // not from employee.address.
        const staticFieldsToFill = [
          'mobileNumber',
          'firstNameEn',
          'lastNameEn',
          'middleNameEn',
          'email',
          'nameEn'
        ];
        
        // Document fields that can be auto-filled from employee documents
        const documentFieldsToFill = [
          'passportCopy',
          'visaPage',
          'birthCertificate',
          'salaryCertificate',
          'labourContract',
          'emiratesId',
          'photo'
        ];
        
        // For each field in our form
        fields.forEach(field => {
          // Check if this field is one we want to auto-fill
          if (staticFieldsToFill.includes(field.name)) {
            // Check if the employee data has this field
            if (employee[field.name] !== undefined && employee[field.name] !== null) {
              // Special validation for emiratesId field to prevent employee ID corruption
              if (field.name === 'emiratesId') {
                // Validate that the value looks like an actual Emirates ID (15 digits with optional dashes)
                // Emirates ID format: 784-YYYY-XXXXXXX-X or 784YYYYXXXXXXXX
                const emiratesIdPattern = /^784[-]?\d{4}[-]?\d{7}[-]?\d$/;
                const employeeIdPattern = /^EMP-/i;
                
                if (employeeIdPattern.test(employee[field.name])) {
                  console.warn(`Skipping auto-fill for emiratesId - employee data contains employee ID instead of Emirates ID:`, employee[field.name]);
                  return; // Skip this field
                } else if (!emiratesIdPattern.test(employee[field.name])) {
                  console.warn(`Skipping auto-fill for emiratesId - invalid format:`, employee[field.name]);
                  return; // Skip this field
                }
              }
              
              console.log(`Auto-filling field ${field.name} with value:`, employee[field.name]);
              
              // Set the field value in the form
              formikRef.current.setFieldValue(field.name, employee[field.name]);
              
              // Mark this field as populated
              setPopulatedFields(prev => new Set([...prev, field.name]));
              
              // Update the field in our state
              setFields(prevFields => prevFields.map(f => {
                if (f.name === field.name) {
                  return { ...f, value: employee[field.name] };
                }
                return f;
              }));
            }
          }
          // Check if this field is a document field we want to auto-fill
          else if (documentFieldsToFill.includes(field.name)) {
            // If already populated from grouped API (this call) or previously, do not override
            if ((populatedFromGrouped && populatedFromGrouped.has(field.name)) || (populatedFields && populatedFields.has(field.name))) {
              console.log(`Skipping legacy autofill for ${field.name} (already populated from grouped API)`);
              return;
            }
            // Process document fields
            handleDocumentFieldAutoFill(field.name, employee, field);
          }
        });
        
        // Also check if any static fields in the service match document fields
        if (documentRequired && documentRequired.length > 0) {
          documentRequired.forEach(docField => {
            if (documentFieldsToFill.includes(docField)) {
              if ((populatedFromGrouped && populatedFromGrouped.has(docField)) || (populatedFields && populatedFields.has(docField))) {
                console.log(`Skipping legacy autofill for ${docField} (already populated from grouped API)`);
                return;
              }
              handleDocumentFieldAutoFill(docField, employee);
            }
          });
        }
      }
    } else {
      formikRef.current.setFieldValue('employeeId', '');
    }
  };

  // Auto-populate fields from employee documents grouped API, and profile (gender)
  const autoPopulateFromBackend = async (employeeUid) => {
    // Track which fields were populated in this call to avoid same-tick overrides
    const populatedFromGrouped = new Set();
    if (!employeeUid) {
      console.warn('No employee UID provided for auto-population');
      return populatedFromGrouped;
    }

    try {
      console.log('=== AUTOFILL DEBUG: Calling employee documents grouped API and employee profile API for employee:', employeeUid);
      
      // Run grouped-docs and employee profile in parallel to reduce latency
      const [groupedResp, profileResp] = await Promise.all([
        AppService.get(`/v1/employee-documents/${employeeUid}/grouped`),
        AppService.get(`/v1/employees/${employeeUid}`).catch((e) => {
          console.warn('Employee profile fetch failed, continuing with grouped docs only:', e?.message || e);
          return null;
        })
      ]);

      console.log('=== AUTOFILL DEBUG: Raw grouped response:', groupedResp);
      if (profileResp) {
        console.log('=== AUTOFILL DEBUG: Raw profile response:', profileResp);
      }

      // Attempt to set gender from employee profile before processing grouped docs
      try {
        const employeeData = profileResp?.data?.data || profileResp?.data || profileResp || null;
        if (employeeData && formikRef?.current) {
          // Autofill email + passportNumber from employee profile (matches on-behalf behavior)
          try {
            const currentValues = formikRef.current.values || {};
            const isEmpty = (v) => v === undefined || v === null || String(v).trim() === '';

            if (Object.prototype.hasOwnProperty.call(currentValues, 'email') && isEmpty(currentValues.email) && employeeData.email) {
              formikRef.current.setFieldValue('email', employeeData.email);
              setPopulatedFields(prev => new Set([...prev, 'email']));
            }

            if (Object.prototype.hasOwnProperty.call(currentValues, 'passportNumber') && isEmpty(currentValues.passportNumber) && employeeData.passportNumber) {
              formikRef.current.setFieldValue('passportNumber', employeeData.passportNumber);
              setPopulatedFields(prev => new Set([...prev, 'passportNumber']));
            }

            // Autofill nameEn from fullName (matches on-behalf behavior)
            if (Object.prototype.hasOwnProperty.call(currentValues, 'nameEn') && isEmpty(currentValues.nameEn) && employeeData.fullName) {
              formikRef.current.setFieldValue('nameEn', employeeData.fullName);
              setPopulatedFields(prev => new Set([...prev, 'nameEn']));
              console.log('=== AUTOFILL DEBUG: nameEn set from fullName:', employeeData.fullName);
            }

            if (Object.prototype.hasOwnProperty.call(currentValues, 'nationality') && isEmpty(currentValues.nationality) && employeeData.nationality) {
              formikRef.current.setFieldValue('nationality', employeeData.nationality);
              setPopulatedFields(prev => new Set([...prev, 'nationality']));
            }

            // Autofill dob from employee profile
            const dobValue = employeeData.dob || employeeData.dateOfBirth || null;
            if (Object.prototype.hasOwnProperty.call(currentValues, 'dob') && isEmpty(currentValues.dob) && dobValue) {
              formikRef.current.setFieldValue('dob', dayjs.utc(dobValue, "YYYY-MM-DD").local());
              setPopulatedFields(prev => new Set([...prev, 'dob']));
              console.log('=== AUTOFILL DEBUG: dob set from employee profile:', dobValue);
            }
          } catch (e) {
            console.warn('=== AUTOFILL DEBUG: Failed to set email/passportNumber/nameEn from employee profile:', e?.message || e);
          }

          if (employeeData.gender) {
          const genderRaw = String(employeeData.gender);
          // Try to locate the gender field among current fields
          let genderField = null;
          if (Array.isArray(fields)) {
            genderField = fields.find(f => {
              const n = (f?.name || '').toLowerCase();
              const c = (f?.code || '').toLowerCase();
              const t = (f?.title || '').toLowerCase();
              return n.includes('gender') || c.includes('gender') || t.includes('gender');
            }) || null;
          }

          const setFormikGender = (fieldName, value) => {
            try {
              formikRef.current.setFieldValue(fieldName, value);
              console.log('=== AUTOFILL DEBUG: Gender set', { fieldName, value });
            } catch (e) {
              console.warn('=== AUTOFILL DEBUG: Failed to set gender field value:', e?.message || e);
            }
          };

          if (genderField && genderField.name) {
            let valueToSet = genderRaw;
            const options = genderField?.options || genderField?.values || [];
            if (Array.isArray(options) && options.length) {
              // Build parallel arrays of option values and labels
              const optionValues = options.map(o => (typeof o === 'object' ? (o.value ?? o.code ?? o.id ?? '') : String(o)) ).filter(Boolean);
              const optionLabels = options.map(o => (typeof o === 'object' ? (o.label ?? o.name ?? '') : String(o)) ).filter(Boolean);

              // Prefer exact/normalized value matches
              const rawU = genderRaw.toUpperCase();
              const rawL = genderRaw.toLowerCase();
              if (optionValues.includes(genderRaw)) {
                valueToSet = genderRaw;
              } else if (optionValues.includes(rawU)) {
                valueToSet = rawU;
              } else if (optionValues.includes(rawL)) {
                valueToSet = rawL;
              } else {
                // Match by label text
                const idxByLabel = optionLabels.findIndex(l => l?.toString().toLowerCase() === rawL);
                if (idxByLabel >= 0) {
                  valueToSet = optionValues[idxByLabel] || optionLabels[idxByLabel];
                } else {
                  // Fallback for common Male/Female label/value mismatches
                  if (rawU === 'MALE') {
                    valueToSet = optionValues.includes('MALE') ? 'MALE' : (optionValues.includes('Male') ? 'Male' : (optionLabels.includes('Male') ? 'Male' : genderRaw));
                  } else if (rawU === 'FEMALE') {
                    valueToSet = optionValues.includes('FEMALE') ? 'FEMALE' : (optionValues.includes('Female') ? 'Female' : (optionLabels.includes('Female') ? 'Female' : genderRaw));
                  }
                }
              }
            }
            setFormikGender(genderField.name, valueToSet);
          } else {
            // Fallback: set by conventional key if present in form values
            const currentValues = formikRef.current.values || {};
            if (Object.prototype.hasOwnProperty.call(currentValues, 'gender')) {
              setFormikGender('gender', genderRaw);
            }
          }
          }
        }
      } catch (e) {
        console.warn('=== AUTOFILL DEBUG: Gender autofill skipped due to error:', e?.message || e);
      }

      console.log('=== AUTOFILL DEBUG: Checking response structure:', {
        hasData: !!groupedResp?.data,
        hasGroups: !!(groupedResp?.data && groupedResp.data.groups),
        groupsLength: groupedResp?.data?.groups?.length,
        groupsArray: groupedResp?.data?.groups,
        hasDirectGroups: !!groupedResp?.groups,
        directGroupsLength: groupedResp?.groups?.length
      });

      // Check if groups are directly in response or in response.data
      const responseData = groupedResp?.data || groupedResp;
      
      if (responseData && responseData.groups && responseData.groups.length > 0) {
        console.log('=== AUTOFILL DEBUG: Employee documents grouped API successful. Groups found:', responseData.groups.length);
        console.log('=== AUTOFILL DEBUG: Full response data:', JSON.stringify(responseData, null, 2));
        
        let populatedFieldsCount = 0;
        
        // Process each document group to extract auto-population data
        responseData.groups.forEach((group, index) => {
          console.log(`=== AUTOFILL DEBUG: Processing group ${index + 1}:`, JSON.stringify(group, null, 2));
          
          // Check if this group is current and has the required data
          if (group.common && group.common.isCurrent && group.documentGroupId) {
            const documentType = group.common.documentType;
            const common = group.common;
            const documentGroupId = group.documentGroupId;
            
            console.log(`=== AUTOFILL DEBUG: Group ${index + 1} is current - documentType: ${documentType}, documentGroupId: ${documentGroupId}`);
            console.log(`=== AUTOFILL DEBUG: Common data:`, JSON.stringify(common, null, 2));
            
            console.log(`Processing current document group: ${documentType} (ID: ${documentGroupId})`);
            
            // Completely generic auto-populate based on documentType and isCurrent flag
            console.log(`=== AUTOFILL DEBUG: Processing ${documentType} - documentNumber: ${common.documentNumber}, issueDate: ${common.issueDate}, expiryDate: ${common.expiryDate}`);
            
            // Get available field names to match against. Static document fields (passportCopy, resume,
            // etc.) live in `staticFields` (rendered by CustomerStatFieldInfo) and may not be in the
            // dynamic `fields` array, so include both — otherwise e.g. resume never gets matched.
            const availableFieldNames = [
              ...fields.map(f => f.name),
              ...(Array.isArray(staticFields) ? staticFields : []),
            ];
            const docTypeLower = documentType.toLowerCase();
            
            // Generic function to convert document type to possible field name variants
            const generateFieldNameVariants = (documentType) => {
              const docTypeLower = documentType.toLowerCase();
              return [
                // Direct document type variations
                documentType,
                docTypeLower,
                docTypeLower.replace(/_/g, ''),
                // Convert snake_case to camelCase
                docTypeLower.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase()),
                // Common variations with proper replacements
                docTypeLower.replace('_copy', 'Copy').replace('_page', 'Page').replace('_certificate', 'Certificate').replace('_contract', 'Contract').replace('_id', 'Id'),
              ].filter(Boolean);
            };
            
            const possibleFieldNames = generateFieldNameVariants(documentType);
            
            console.log(`=== AUTOFILL DEBUG: Generated field variants for ${documentType}:`, possibleFieldNames);
            console.log(`=== AUTOFILL DEBUG: Available field names:`, availableFieldNames);
            
            // Find the actual field name that exists in the form
            let fieldName = null;
            for (const variant of possibleFieldNames) {
              if (availableFieldNames.includes(variant)) {
                fieldName = variant;
                console.log(`=== AUTOFILL DEBUG: Found matching field: ${fieldName} for document type: ${documentType}`);
                break;
              } else {
                console.log(`=== AUTOFILL DEBUG: Field variant ${variant} not found in available fields`);
              }
            }
            
            if (!fieldName) {
              console.log(`=== AUTOFILL DEBUG: No matching field found for ${documentType}. Available fields:`, availableFieldNames);
              console.log(`=== AUTOFILL DEBUG: Generated variants:`, possibleFieldNames);
            }
            
            // If no direct match, try to find by checking STAT_FIELDS configuration
            if (!fieldName) {
              for (const availableField of availableFieldNames) {
                if (STAT_FIELDS[availableField]) {
                  // Check if this field could be related to the document type
                  const fieldLower = availableField.toLowerCase();
                  const docTypeWords = docTypeLower.split('_');
                  if (docTypeWords.some(word => fieldLower.includes(word))) {
                    fieldName = availableField;
                    break;
                  }
                }
              }
            }
            
            console.log(`=== AUTOFILL DEBUG: Found field name: ${fieldName} for document type: ${documentType}`);
            
            // Check if this is a document field (FILE type) or text field
            // Special case: emiratesId can be both text and file field depending on context
            const isDocField = fieldName && (
              (STAT_FIELDS[fieldName] && STAT_FIELDS[fieldName].type === 'FILE') ||
              (fieldName === 'emiratesId' && documentType === 'emirates_id' && group.documents && group.documents.length > 0)
            );
            console.log(`=== AUTOFILL DEBUG: Field ${fieldName} type check - isDocField: ${isDocField}, STAT_FIELDS type: ${fieldName ? STAT_FIELDS[fieldName]?.type : 'N/A'}, hasDocuments: ${!!(group.documents && group.documents.length > 0)}`);
            
            if (isDocField) {
              // Handle document/file fields
              if (group.documents && group.documents.length > 0) {
                console.log(`=== AUTOFILL DEBUG: Found ${group.documents.length} ${documentType} documents`);
                
                const documentReferences = group.documents.map(d => ({
                  fieldName: fieldName,
                  documentGroupId: documentGroupId,
                  documentType: fieldName,
                  id: d.id,
                  documentId: d.id,
                  fileName: d.fileName,
                  filePath: d.filePath,
                  contentType: d.contentType,
                  fileSize: d.fileSize,
                  isPrimary: !!d.isPrimary,
                  uploadDate: d.uploadDate,
                }));
                
                const primaryDoc = group.documents.find(doc => doc.isPrimary) || group.documents[0];
                const fileMetadata = {
                  id: primaryDoc.id,
                  fileName: primaryDoc.fileName,
                  filePath: primaryDoc.filePath,
                  contentType: primaryDoc.contentType,
                  fileSize: primaryDoc.fileSize,
                  documentType: fieldName,
                  employeeUid: responseData.uid,
                  documentReferences,
                  hasMultipleFiles: group.documents.length > 1,
                  totalFiles: group.documents.length
                };
                
                autoFillField(fieldName, fileMetadata, documentGroupId);
                populatedFromGrouped.add(fieldName);
                populatedFieldsCount++;
              }
            } else {
              // Handle text fields - populate with document number
              if (common.documentNumber) {
                autoFillField(fieldName, common.documentNumber, documentGroupId);
                populatedFromGrouped.add(fieldName);
                populatedFieldsCount++;
              }
            }
            
            // Auto-populate related fields dynamically using generic field name patterns
            if (fieldName) {
              // Document number fields
              if (common.documentNumber) {
                const baseFieldName = docTypeLower.replace('_', '');
                const numberFieldVariants = [
                  `${fieldName}Number`, // e.g., emiratesIdNumber
                  `${baseFieldName}Number`, // e.g., emiratesidNumber
                  `${baseFieldName}_number`, // e.g., emiratesid_number
                  `${docTypeLower}_number`, // e.g., emirates_id_number
                  `${documentType}_number` // e.g., emirates_id_number
                ];
                
                numberFieldVariants.forEach(variant => {
                  if (availableFieldNames.includes(variant)) {
                    autoFillField(variant, common.documentNumber, documentGroupId);
                    populatedFieldsCount++;
                  }
                });
              }
              
              // Issue date fields  
              if (common.issueDate) {
                const baseFieldName = docTypeLower.replace('_', '');
                const issueDateFieldVariants = [
                  `${fieldName}IssueDate`, // e.g., emiratesIdIssueDate
                  `${fieldName}Issue`, // e.g., emiratesIdIssue
                  `${baseFieldName}IssueDate`, // e.g., emiratesidIssueDate
                  `${baseFieldName}_issue_date`, // e.g., emiratesid_issue_date
                  `${docTypeLower}_issue_date`, // e.g., emirates_id_issue_date
                  `${documentType}_issue_date`, // e.g., emirates_id_issue_date
                  `${documentType}_issueDate` // e.g., emirates_id_issueDate
                ];
                // If this is a visa document, also include canonical visa keys
                if (docTypeLower.includes('visa')) {
                  issueDateFieldVariants.unshift('visaIssueDate', 'visaIssue');
                }
                
                issueDateFieldVariants.forEach(variant => {
                  if (availableFieldNames.includes(variant)) {
                    autoFillField(variant, common.issueDate, documentGroupId);
                    populatedFieldsCount++;
                  }
                });
                // Additionally, if canonical visaIssueDate exists in form, set it
                if (docTypeLower.includes('visa') && availableFieldNames.includes('visaIssueDate')) {
                  autoFillField('visaIssueDate', common.issueDate, documentGroupId);
                }
              }
              
              // Expiry date fields
              if (common.expiryDate) {
                const baseFieldName = docTypeLower.replace('_', '');
                const expiryDateFieldVariants = [
                  `${fieldName}ExpiryDate`, // e.g., emiratesIdExpiryDate
                  `${fieldName}Expiry`, // e.g., emiratesIdExpiry
                  `${baseFieldName}ExpiryDate`, // e.g., emiratesidExpiryDate
                  `${baseFieldName}_expiry_date`, // e.g., emiratesid_expiry_date
                  `${docTypeLower}_expiry_date`, // e.g., emirates_id_expiry_date
                  `${documentType}_expiry_date`, // e.g., emirates_id_expiry_date
                  `${documentType}_expiryDate` // e.g., emirates_id_expiryDate
                ];
                // If this is a visa document, also include canonical visa keys
                if (docTypeLower.includes('visa')) {
                  expiryDateFieldVariants.unshift('visaExpiryDate', 'visaExpiry');
                }
                
                expiryDateFieldVariants.forEach(variant => {
                  if (availableFieldNames.includes(variant)) {
                    autoFillField(variant, common.expiryDate, documentGroupId);
                    populatedFieldsCount++;
                  }
                });
                // Additionally, if canonical visaExpiryDate exists in form, set it
                if (docTypeLower.includes('visa') && availableFieldNames.includes('visaExpiryDate')) {
                  autoFillField('visaExpiryDate', common.expiryDate, documentGroupId);
                }
              }
            }
          } else {
            console.log(`=== AUTOFILL DEBUG: Group ${index + 1} skipped - isCurrent: ${group.common?.isCurrent}, hasDocumentGroupId: ${!!group.documentGroupId}`);
          }
        });

        // Multiple-instance certificates (educational/experience) can have several current groups —
        // one per title. The generic loop above maps each group to a single field and overwrites, so
        // aggregate every current group's documents into one field value so all certificates pre-load.
        try {
          const multiInstanceTargets = [
            { name: 'educationalCertificate', match: (dt) => dt.includes('education') && dt.includes('cert') },
            { name: 'experienceCertificate', match: (dt) => dt.includes('experience') && dt.includes('cert') },
          ];
          const isOnForm = (name) => (Array.isArray(staticFields) && staticFields.includes(name)) || fields.some(f => f.name === name);
          multiInstanceTargets.forEach(({ name, match }) => {
            if (!isOnForm(name)) return;
            const grps = responseData.groups.filter(g => g?.common?.isCurrent && g?.documentGroupId && match((g.common.documentType || '').toLowerCase()));
            if (grps.length === 0) return;
            const refs = [];
            grps.forEach(gr => (Array.isArray(gr.documents) ? gr.documents : []).forEach(d => refs.push({
              id: d.id,
              documentId: d.id,
              fileName: d.fileName,
              filePath: d.filePath,
              documentType: name,
              documentGroupId: gr.documentGroupId,
              isPrimary: !!d.isPrimary,
            })));
            if (refs.length === 0) return;
            const primary = refs.find(r => r.isPrimary) || refs[0];
            formikRef.current.setFieldValue(name, {
              isReference: true,
              documentType: name,
              employeeUid: responseData.uid || employeeUid,
              id: primary.id,
              fileName: primary.fileName || name,
              documentGroupId: primary.documentGroupId,
              hasMultipleFiles: refs.length > 1,
              totalFiles: refs.length,
              documentReferences: refs,
            });
            populatedFromGrouped.add(name);
            setPopulatedFields(prev => new Set([...prev, name]));
          });
        } catch (e) {
          console.warn('Multi-instance certificate autofill failed:', e?.message || e);
        }

        if (populatedFieldsCount > 0) {
          dispatch(showSuccessMessage(`Auto-populated ${populatedFieldsCount} fields from employee documents`));
        } else {
          console.log('=== AUTOFILL DEBUG: No current documents found for auto-population');
        }
        return populatedFromGrouped;
      } else {
        console.log('=== AUTOFILL DEBUG: No document groups found for employee - condition failed');
        console.log('=== AUTOFILL DEBUG: Condition details:', {
          hasResponseData: !!responseData,
          hasGroups: !!(responseData && responseData.groups),
          groupsLength: responseData?.groups?.length,
          actualGroups: responseData?.groups,
          hasDirectGroups: !!groupedResp?.groups,
          directGroupsLength: groupedResp?.groups?.length
        });
        return populatedFromGrouped;
      }
    } catch (error) {
      console.error('Employee documents API call failed:', error);
      // Don't show error to user as this is optional functionality
    }
    return populatedFromGrouped;
  };

  // Helper function to auto-fill a specific field
  const autoFillField = (fieldName, value, documentGroupId = null) => {
    if (value !== null && value !== undefined) {
      console.log(`Auto-populating field ${fieldName} with value:`, value, documentGroupId ? `(from group: ${documentGroupId})` : '');
      
      // A field may live in the dynamic `fields` array OR only in `staticFields` (static document
      // fields like resume are rendered by CustomerStatFieldInfo and read their value from Formik).
      // Always set the Formik value below; only touch the `fields` state when the field is in it.
      const fieldExists = fields.find(f => f.name === fieldName);
      
      // Convert date strings to Day.js objects for date picker fields
      let processedValue = value;
      const isDateField = fieldName.toLowerCase().includes('date') || 
                         fieldName.toLowerCase().includes('expiry') || 
                         fieldName.toLowerCase().includes('issue');
      
      if (isDateField && typeof value === 'string' && value.trim() !== '') {
        try {
          // Convert string date to Day.js object
          processedValue = dayjs(value);
          console.log(`=== AUTOFILL DEBUG: Converted date string "${value}" to Day.js object for field ${fieldName}`);
        } catch (error) {
          console.error(`=== AUTOFILL ERROR: Failed to convert date string "${value}" to Day.js object for field ${fieldName}:`, error);
          processedValue = value; // Keep original value if conversion fails
        }
      }
      
      // Set the field value in the form
      formikRef.current.setFieldValue(fieldName, processedValue);
      
      // Mark this field as populated
      setPopulatedFields(prev => new Set([...prev, fieldName]));
      
      // Update the field in our state (dynamic fields only; static fields read from Formik values)
      if (fieldExists) {
        setFields(prevFields => prevFields.map(f => {
          if (f.name === fieldName) {
            return {
              ...f,
              value: value,
              // Store the documentGroupId for reference if provided
              documentGroupId: documentGroupId || f.documentGroupId
            };
          }
          return f;
        }));
      }
    }
  };

  // Write newly-uploaded documents back to the employee's document profile just before the ticket is
  // created (mirrors the New Workflow Request form). Files are already on S3 (uploaded at select time);
  // here we bulk-save them so the profile write and the ticket link happen together at submit. Raw
  // single-instance uploads become the employee's current version; multiple-instance certificate popup
  // values are saved one group per titled certificate. `values` is mutated in place so the existing
  // documentReferences-collection below picks up the resulting documentGroupIds.
  const syncNewUploadsToEmployeeDocuments = async (values) => {
    try {
      const uid = values.employeeUid || selectedEmployee?.uid || selectedEmployee?.employeeId;
      if (!uid) return;
      const bulkUrl = `/v1/employee-documents/${uid}/bulk`;
      const lastSeg = (p) => (typeof p === 'string' ? p.split('/').pop() : '') || 'Document';
      const multiInstance = new Set(['educationalCertificate', 'experienceCertificate']);
      const staticDocFields = [
        'passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 'labourContract',
        'emiratesId', 'photo', 'shinasnama', 'resume', 'policeClearanceCertificate',
        'educationalCertificate', 'experienceCertificate'
      ];

      for (const code of staticDocFields) {
        const value = values[code];
        // Only newly-entered uploads / certificate-popup values that are NOT already employee-doc references.
        if (!value || typeof value !== 'object' || value.isReference) continue;

        // Multiple-instance certificate popup value: bulk-save each titled sub as its own group.
        if (value.isMultiCertificate && Array.isArray(value.subs)) {
          const certBackend = value.backendDocumentType || DOCUMENT_TYPE_MAPPING[code];
          if (!certBackend) continue;
          const allRefs = Array.isArray(value.existingRefs) ? [...value.existingRefs] : [];
          let firstGroupId = allRefs.length ? allRefs[0].documentGroupId : null;
          let primaryDoc = null;
          for (const sub of value.subs) {
            const title = (sub.title || '').trim();
            const files = Array.isArray(sub.files) ? sub.files.filter(f => f.filePath) : [];
            if (!title || files.length === 0) continue;
            try {
              // eslint-disable-next-line no-await-in-loop
              const resp = await apiService.api.post(bulkUrl, {
                documentType: certBackend,
                replaceExisting: false, // add as a new titled certificate group (becomes current)
                title,
                isReplace: false,
                // Use the certificate name as the saved file name (matching the employee-detail page),
                // suffixing when a certificate holds more than one file.
                documents: files.map((f, idx) => ({ filePath: f.filePath, fileName: files.length > 1 ? `${title} (${idx + 1})` : title, contentType: f.contentType || null, fileSize: f.fileSize || null })),
              }, { headers: { 'Content-Type': 'application/json' } });
              const saved = resp?.data?.data || resp?.data || [];
              const docs = Array.isArray(saved) ? saved : [];
              docs.forEach(d => {
                allRefs.push({ id: d.id, documentId: d.id, fileName: d.fileName, filePath: d.filePath, documentType: code, documentGroupId: d.documentGroupId, isPrimary: !!d.isPrimary });
                if (!firstGroupId) firstGroupId = d.documentGroupId;
                if (!primaryDoc) primaryDoc = d;
              });
            } catch (e) {
              console.warn(`Could not save certificate "${title}" for ${code}; it will be omitted`, e);
            }
          }
          if (allRefs.length > 0) {
            values[code] = {
              isReference: true, documentType: code, backendDocumentType: certBackend, employeeUid: uid,
              id: primaryDoc ? primaryDoc.id : allRefs[0].id, fileName: primaryDoc ? primaryDoc.fileName : allRefs[0].fileName,
              documentGroupId: firstGroupId, hasMultipleFiles: allRefs.length > 1, totalFiles: allRefs.length, documentReferences: allRefs,
            };
          }
          continue;
        }

        // Single-instance raw upload (has a filePath and is not yet a saved group). A multi-file upload
        // (from the multi-select document field) carries all its files in documentReferences with an
        // isNewUpload flag.
        const isNewMultiUpload = value.isNewUpload === true && Array.isArray(value.documentReferences) && value.documentReferences.length > 0;
        const filePath = value.filePath || value.path;
        // Skip values that already reference an employee-profile document (auto-filled from the profile
        // or saved earlier). Re-bulking those would create a spurious new version and, because the value
        // only carries the primary file, would drop the group's other files. Freshly staged uploads
        // (isNewUpload) are NOT skipped even though they carry documentReferences.
        const alreadyOnProfile = !isNewMultiUpload && (!!value.documentGroupId ||
          (Array.isArray(value.documentReferences) && value.documentReferences.length > 0));
        if ((!filePath && !isNewMultiUpload) || alreadyOnProfile || multiInstance.has(code)) continue;
        const backendType = DOCUMENT_TYPE_MAPPING[code] || code.replace(/([A-Z])/g, '_$1').toLowerCase();
        if (!backendType) continue;
        const singleInstanceDocs = isNewMultiUpload
          ? value.documentReferences.map(r => ({ filePath: r.filePath, fileName: r.fileName || lastSeg(r.filePath), contentType: r.contentType || null, fileSize: r.fileSize || null }))
          : [{ filePath, fileName: value.fileName || lastSeg(filePath), contentType: value.contentType || value.fileType || null, fileSize: value.fileSize || null }];
        try {
          // eslint-disable-next-line no-await-in-loop
          const resp = await apiService.api.post(bulkUrl, {
            documentType: backendType,
            replaceExisting: true, // the freshly uploaded file(s) become the employee's current version
            documents: singleInstanceDocs,
          }, { headers: { 'Content-Type': 'application/json' } });
          const saved = resp?.data?.data || resp?.data || [];
          const docs = Array.isArray(saved) ? saved : [];
          if (docs.length === 0) continue;
          const primary = docs.find(d => d.isPrimary) || docs[0];
          values[code] = {
            isReference: true, documentType: code, backendDocumentType: backendType, employeeUid: uid,
            id: primary.id, fileName: primary.fileName || value.fileName || lastSeg(filePath), documentGroupId: primary.documentGroupId,
            documentReferences: docs.map(d => ({ id: d.id, documentId: d.id, fileName: d.fileName, filePath: d.filePath, documentType: code, documentGroupId: d.documentGroupId, isPrimary: !!d.isPrimary })),
          };
        } catch (e) {
          console.warn(`Could not save uploaded ${code} to employee profile; submitting as a plain upload`, e);
        }
      }
    } catch (e) {
      console.warn('syncNewUploadsToEmployeeDocuments failed', e);
    }
  };

  const _onSubmit = async (values, { resetForm, setSubmitting, setErrors }) => {
    console.log("Submitting form with values:", values);

    values.assignedTo = ticketAssignedTo;

    // Validate that an employee is selected if there are file uploads
    if (!values.employeeUid && hasFileUploads(values)) {
      console.error('No employee selected but file uploads are present');
      dispatch(dismissLoader());
      setErrors({ employee: 'Please select an employee before submitting the form with file uploads' });
      setSubmitting(false);
      dispatch(showErroMessage("Please select an employee before submitting the form with file uploads"));
      return;
    }

    dispatch(showLoader());

    // Bulk-save newly uploaded documents to the employee profile just before creating the ticket.
    await syncNewUploadsToEmployeeDocuments(values);

    // Prepare fields object with proper structure for the backend
    console.log("Preparing fields for submission");
    let fieldsObj = {};
    
    // Document fields that might contain references to existing documents
    const documentFields = [
      'passportCopy',
      'visaPage',
      'birthCertificate',
      'salaryCertificate',
      'labourContract',
      'emiratesId',
      'photo',
      'resume',
      'policeClearanceCertificate',
      'educationalCertificate',
      'experienceCertificate'
    ];
    
    // Collect document IDs from document references to include in the request
    const documentIds = [];
    
    // Track document references for detailed logging
    const documentReferences = [];
    // Collect detailed document metadata for backend (will merge in sanitize)
    const collectedDocumentMetadata = [];
    
    // Preserve document field values for documentReferences collection before clearing
    // Check both Formik values AND fields state (for newly uploaded docs)
    const preservedDocumentValues = {};
    documentFields.forEach(fieldName => {
      // First check Formik values
      if (values[fieldName] && typeof values[fieldName] === 'object') {
        preservedDocumentValues[fieldName] = { ...values[fieldName] };
        
        if (values[fieldName].isReference) {
          console.log(`Converting document reference object to string ID for ${fieldName}:`, values[fieldName].id);
          values[fieldName] = values[fieldName].id;
        } else if (fieldName === 'emiratesId' && values[fieldName].documentNumber) {
          console.log(`Converting auto-filled emiratesId object to document number string:`, values[fieldName].documentNumber);
          values[fieldName] = values[fieldName].documentNumber;
        } else if (values[fieldName].fileName || values[fieldName].filePath) {
          console.log(`Preserving document object for ${fieldName} for documentReferences, then clearing from values`);
          values[fieldName] = null;
        }
      }
      
      // Also check fields state for newly uploaded documents (may not be in Formik values yet)
      const fieldFromState = fields.find(f => f.name === fieldName);
      if (fieldFromState?.value && typeof fieldFromState.value === 'object') {
        // If not already preserved from Formik values, use field state value
        if (!preservedDocumentValues[fieldName]) {
          preservedDocumentValues[fieldName] = { ...fieldFromState.value };
          console.log(`Preserved document from fields state for ${fieldName}:`, {
            documentGroupId: fieldFromState.value.documentGroupId,
            fileName: fieldFromState.value.fileName
          });
        }
        // Also check if field has documentGroupId directly (set by _onFileUpload)
        if (fieldFromState.documentGroupId && !preservedDocumentValues[fieldName]?.documentGroupId) {
          preservedDocumentValues[fieldName] = preservedDocumentValues[fieldName] || {};
          preservedDocumentValues[fieldName].documentGroupId = fieldFromState.documentGroupId;
          console.log(`Added documentGroupId from field state for ${fieldName}:`, fieldFromState.documentGroupId);
        }
      }
    });
    
    
    // First, collect document references from preserved values (handles ALL static doc fields)
    documentFields.forEach(fieldName => {
      const fieldValue = preservedDocumentValues[fieldName];
      if (!fieldValue) return;
      
      console.log(`Processing preserved document field ${fieldName}:`, {
        documentGroupId: fieldValue.documentGroupId,
        fileName: fieldValue.fileName,
        hasDocumentReferences: !!fieldValue.documentReferences
      });
      
      // If we have grouped document references array
      const refs = Array.isArray(fieldValue.documentReferences) ? fieldValue.documentReferences : [];
      if (refs.length > 0) {
        refs.forEach((ref) => {
          if (ref?.documentGroupId) {
            documentReferences.push({
              documentGroupId: ref.documentGroupId,
              documentType: fieldName,
              fileName: ref?.fileName || `${fieldName}.pdf`,
              filePath: ref?.filePath || fieldValue?.filePath || null,
              documentId: ref?.id || ref?.documentId || null,
            });
            console.log(`Added document reference from refs array for ${fieldName}:`, ref.documentGroupId);
          }
        });
      } else if (fieldValue.documentGroupId) {
        // Newly uploaded file with documentGroupId from bulk API
        documentReferences.push({
          documentGroupId: fieldValue.documentGroupId,
          documentType: fieldValue.documentType || fieldName,
          fileName: fieldValue.fileName || `${fieldName}.pdf`,
          filePath: fieldValue.filePath || null,
          documentId: fieldValue.id || null,
        });
        console.log(`Added newly uploaded document to documentReferences for ${fieldName}:`, fieldValue.documentGroupId);
      }
    });
    
    // Add service fields - backend expects Map<UUID, String>
    fields.forEach((field) => {
      // Dynamic text/select fields store their value in the `fields` state (field.value) via
      // _onTextChange and are NOT written to Formik, so prefer values[field.name] only when Formik
      // actually holds it (file fields) and fall back to field.value — otherwise typed values like a
      // mandatory "Highest Qualification" are dropped and the backend rejects the ticket.
      const fieldValue = (values && field?.name && values[field.name] !== undefined)
        ? values[field.name]
        : field.value;

      // Check if field.id is a UUID before adding it to fieldsObj
      const uuidKeyRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
      if (!uuidKeyRegex.test(field.id)) {
        // Skip non-UUID fields (static fields like passportCopy, visaPage, etc.)
        return;
      }

      const isStaticDocumentField = documentFields.includes(field.name);

      if (isStaticDocumentField) {
        // Handle static document fields: may have multiple references
        if (fieldValue && typeof fieldValue === 'object') {
          // If we have grouped document references
          const refs = Array.isArray(fieldValue.documentReferences) ? fieldValue.documentReferences : [];
          if (refs.length > 0) {
            refs.forEach((ref) => {
              // If this reference has a documentGroupId, treat it as an employee document reference
              if (ref?.documentGroupId) {
                documentReferences.push({
                  documentGroupId: ref.documentGroupId,
                  documentType: field.name,
                  fileName: ref?.fileName || `${field.name}.pdf`,
                  // Provide more metadata so backend can fully associate
                  filePath: ref?.filePath || fieldValue?.filePath || null,
                  documentId: ref?.id || ref?.documentId || null,
                  isPrimary: ref?.isPrimary ?? undefined,
                });
                // IMPORTANT: Do NOT push employee document ids into documentIds (those are for t_user_document only)
                return;
              }

              // Legacy path: use documentId/id and include in documentIds
              const docId = ref?.documentId || ref?.id || ref; // tolerate shapes
              const idStr = typeof docId === 'string' ? docId : (docId?.toString?.() || '');
              const uuidValRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
              if (uuidValRegex.test(idStr)) {
                documentIds.push(idStr);
                documentReferences.push({
                  documentId: idStr,
                  documentType: field.name,
                  fileName: ref?.fileName || `${field.name}.pdf`,
                });
                collectedDocumentMetadata.push({
                  id: idStr,
                  fileName: ref?.fileName || `${field.name}.pdf`,
                  fieldName: field.name,
                  documentType: field.name,
                });
              }
            });
          } else if (fieldValue.documentGroupId) {
            // Newly uploaded file with documentGroupId from bulk API
            documentReferences.push({
              documentGroupId: fieldValue.documentGroupId,
              documentType: fieldValue.documentType || field.name,
              fileName: fieldValue.fileName || `${field.name}.pdf`,
              filePath: fieldValue.filePath || null,
              documentId: fieldValue.id || null,
            });
            console.log(`Added newly uploaded document to documentReferences:`, {
              documentGroupId: fieldValue.documentGroupId,
              documentType: fieldValue.documentType || field.name,
              fileName: fieldValue.fileName
            });
          } else if (fieldValue.id) {
            // Single reference object fallback (legacy)
            const idStr = fieldValue.id;
            const uuidValRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            if (typeof idStr === 'string' && uuidValRegex.test(idStr)) {
              // Legacy path for user documents is disabled for static employee doc fields
              // Do not push into documentIds; prefer group-based references only
            }
          } else {
            // Fallback: if field has a documentGroupId stored (from autoFill or upload), send a single group-based reference
            const fallbackGroupId = field?.documentGroupId;
            if (fallbackGroupId) {
              documentReferences.push({
                documentGroupId: fallbackGroupId,
                documentType: field.name,
                fileName: `${field.name}.pdf`
              });
            }
          }

          // Maintain uidDetails mapping of primary doc id for compatibility when employeeUid present
          if (selectedEmployee && selectedEmployee.uid) {
            const primaryId = fieldValue.id || fieldValue.documentId;
            if (primaryId) {
              if (!values.uidDetails) values.uidDetails = {};
              const documentTypeKey = field.name.replace(/([A-Z])/g, '_$1').toLowerCase();
              values.uidDetails[documentTypeKey] = primaryId;
            }
          }
        } else if (typeof fieldValue === 'string') {
          // Legacy string UUID for static doc field: do not include in documentIds; clear field to avoid sending it
        } else if (!fieldValue && field?.documentGroupId) {
          // Field value is null/undefined but field has documentGroupId from upload callback
          documentReferences.push({
            documentGroupId: field.documentGroupId,
            documentType: field.name,
            fileName: field.value?.fileName || `${field.name}.pdf`
          });
          console.log(`Added document from field.documentGroupId fallback:`, {
            documentGroupId: field.documentGroupId,
            documentType: field.name
          });
        }
        // Ensure static document fields are NOT sent as top-level values in payload
        values[field.name] = '';
        // Static document fields are NOT added to fieldsObj
        return;
      }

      // Dynamic service fields: backend expects Map<UUID, String>. A document/file uploaded for a
      // dynamic field arrives as an object (file metadata), which cannot be deserialized into a String
      // — store its file path so the value is a plain string and the ticket detail can render it as a
      // document. Non-object values (text, date strings) pass through unchanged.
      let dynamicFieldValue = fieldValue;
      if (dynamicFieldValue && typeof dynamicFieldValue === 'object') {
        dynamicFieldValue = dynamicFieldValue.filePath || dynamicFieldValue.path ||
          dynamicFieldValue.documentUrl || dynamicFieldValue.s3Key || dynamicFieldValue.id || '';
      }
      console.log(`Adding service field ${field.id} with value`, dynamicFieldValue);
      fieldsObj[field.id] = dynamicFieldValue;
    });
    
    // If employee ticket but no refs collected yet, derive from fields state (submit-time fallback)
    if (values && values.employeeUid && documentReferences.length === 0) {
      const staticDocFields = [
        'passportCopy', 'visaPage', 'birthCertificate', 'salaryCertificate', 'labourContract', 'emiratesId', 'photo',
        'resume', 'policeClearanceCertificate', 'educationalCertificate', 'experienceCertificate'
      ];
      fields.forEach((fld) => {
        if (staticDocFields.includes(fld.name) && fld.documentGroupId) {
          documentReferences.push({
            documentGroupId: fld.documentGroupId,
            documentType: fld.name,
          });
        }
      });
    }

    // Log document references for debugging
    if (documentReferences.length > 0) {
      console.log('Document references collected:', {
        count: documentReferences.length,
        references: documentReferences,
        timestamp: new Date().toISOString()
      });
      
      // Format document references for the backend if this is an employee ticket
      if (values && values.employeeUid) {
        const formattedDocumentReferences = documentReferences.map(ref => {
          // Employee document reference by group
          if (ref.documentGroupId) {
            return {
              documentGroupId: ref.documentGroupId,
              documentType: ref.documentType,
            };
          }
          // Legacy user document by id
          return {
            id: ref.documentId,
            documentType: ref.documentType,
            employeeUid: values.employeeUid,
          };
        });
        
        // Add to the request payload
        values.documentReferences = formattedDocumentReferences;
        
        console.log(`Added ${formattedDocumentReferences.length} formatted document references to request payload`);
      }
    }
    // Attach collected document metadata before sanitization
    if (collectedDocumentMetadata.length > 0) {
      values.documentMetadata = collectedDocumentMetadata;
      console.log(`Collected ${collectedDocumentMetadata.length} document metadata entries`);
    }
    
    // Add the collected document IDs to the request
    if (documentIds.length > 0) {
      console.log(`Adding ${documentIds.length} document IDs to the request:`, documentIds);
      values.documentIds = documentIds;
      
      // Add document count to the request for tracking
      values.documentCount = documentIds.length;
      
      // If employee is selected and has a UID, add document association
      if (selectedEmployee && selectedEmployee.uid) {
        // Ensure we have a documentAssociations object
        values.documentAssociations = {
          employeeUid: selectedEmployee.uid,
          documentIds: documentIds
        };
        console.log('Added document associations with employee UID:', selectedEmployee.uid);
      }
    } else {
      // Initialize empty array for documentIds if none were found
      // This ensures the backend always receives a documentIds field
      values.documentIds = [];
      values.documentCount = 0;
      console.log("No document references found, initializing empty documentIds array");
    }
    
    // Customer fields list for reference only
    // These are included as top-level properties in the request, NOT in the fields object
    const customerFields = [
      "uid", "customerName", "firstNameEn", "middleNameEn", "lastNameEn", 
      "nameEn", "mobileNumber", "email", "gender"
    ];
    
    // IMPORTANT: Do NOT add string keys to fieldsObj as the backend expects UUID keys
    // Customer fields are already included as top-level properties in the values object
    console.log("Customer fields are included as top-level properties only");
    
    // Set the fields in the request as expected by the backend
    values.fields = fieldsObj;
    
    // Log the correct format being sent to the backend
    console.log("Fields object with UUID keys only:", fieldsObj);
    
    // Enhanced UID validation with detailed logging
    console.log("Validating UID before submission:", { 
      uid: uid, 
      formUid: values.uid, 
      uidTrimmed: uid ? uid.trim() : 'undefined',
      uidLength: uid ? uid.length : 0,
      isUidReady: isUidready,
      hasSelectedEmployee: !!selectedEmployee
    });
    
    // IMPORTANT: Customer UID is required for ticket creation
    // The backend TTicket entity requires a uid field
    
    // Check if we're creating a new customer during submission
    if (values.isNewCustomer === true) {
      console.log("Creating new customer - backend will generate a UID");
      
      // Ensure all required customer fields are present
      const requiredFields = ['firstNameEn', 'lastNameEn', 'mobileNumber'];
      const missingFields = requiredFields.filter(field => !values[field]);
      
      if (missingFields.length > 0) {
        console.error("Missing required fields for new customer:", missingFields);
        dispatch(showErroMessage(`Please provide ${missingFields.join(', ')} for the new customer.`));
        dispatch(dismissLoader());
        return;
      }
      
      // Log new customer data
      console.log("New customer data:", {
        firstNameEn: values.firstNameEn,
        middleNameEn: values.middleNameEn,
        lastNameEn: values.lastNameEn,
        mobileNumber: values.mobileNumber,
        email: values.email
      });
    }
    // Check if UID is in the form values
    else if (values.uid && values.uid.trim() !== "") {
      console.log("Using UID from form values:", values.uid);
      // Keep the existing UID in values
    } 
    // If not in form values, check if it's in the component state
    else if (uid && uid.trim() !== "") {
      console.log("Using UID from component state:", uid);
      values.uid = uid;
    } 
    // If neither source has a valid UID, show error
    else {
      console.error("UID validation failed: No valid UID found in form or state");
      dispatch(showErroMessage("Customer UID is required. Please enter a valid UID or search for customer details."));
      dispatch(dismissLoader());
      return;
    }
    
    console.log("Customer UID validation passed. Using UID:", values.uid || "<will be generated by backend>");
    
    // Helper function to ensure proper employeeId format
    const formatEmployeeId = (employee) => {
      // If employeeId is available, use it directly
      if (employee.employeeId && employee.employeeId.trim() !== '') {
        return employee.employeeId;
      }
      
      // If only uid is available, try to extract employeeId format
      if (employee.uid && employee.uid.trim() !== '') {
        // Check if uid is in the format "EMP-20250709-6879"
        const uidParts = employee.uid.split('-');
        if (uidParts.length >= 2) {
          // Return "EMP-455" format if possible
          return `${uidParts[0]}-${uidParts[uidParts.length - 1]}`;
        }
        // Otherwise, use the uid as is
        return employee.uid;
      }
      
      // If neither is available, return null
      return null;
    };
    
    // Handle employee data properly to prevent fetch errors
    if (selectedEmployee) {
      // For employee assignment, we need to use the employeeId format (e.g., "EMP-455")
      // The backend expects employeeId for ticket assignment
      const employeeId = formatEmployeeId(selectedEmployee);
      
      if (!employeeId) {
        console.error("No valid employeeId could be determined from employee data");
        dispatch(showErroMessage("Invalid employee data. Please select a valid employee."));
        dispatch(dismissLoader());
        return;
      }
      
      // Validate employee UID
      if (!selectedEmployee.uid) {
        console.error("Employee UID is missing");
        dispatch(showErroMessage("Employee UID is required. Please select a valid employee."));
        dispatch(dismissLoader());
        return;
      }
      
      console.log("Using employee ID for ticket assignment:", employeeId);
      console.log("Using employee UID for document associations:", selectedEmployee.uid);
      
      // Create a clean copy of employee data for submission
      const employeeDataForSubmission = {
        uid: selectedEmployee.uid, // Add UID for document associations
        employeeId: employeeId, // This is the key field the backend needs
        nameEn: selectedEmployee.nameEn || `${selectedEmployee.firstNameEn || ''} ${selectedEmployee.lastNameEn || ''}`.trim(),
        department: selectedEmployee.department?.departmentName || '',
        position: selectedEmployee.position?.positionName || ''
      };
      
      // Log the employee data being submitted
      console.log("Employee data prepared for submission:", employeeDataForSubmission);
      
      // Set the cleaned employee data in the values object
      values.employee = employeeDataForSubmission;
      
      // Add employeeId as a separate field for clarity - this is what the backend expects
      values.employeeId = employeeId;
      
      // Add employeeUid as a separate field for the new backend implementation
      if (selectedEmployee.uid) {
        values.employeeUid = selectedEmployee.uid;
        console.log("Adding employeeUid to request payload:", selectedEmployee.uid);
      }
      
      // If we have a photo URL from the employee data, include it
      if (selectedEmployee.photo) {
        console.log("Including employee photo URL in submission:", selectedEmployee.photo);
        values.employee.photo = selectedEmployee.photo;
      }
      
      // IMPORTANT: Link employee UID with uidDetails for compatibility with pre-refactor code
      // This ensures the ticket is properly associated with the employee in the TTicketUidDetails table
      if (selectedEmployee.uid) {
        // Include the full employee UID in the uidDetails
        values.uidDetails = {
          uid: selectedEmployee.uid,
          type: 'EMPLOYEE', // This maps to UidType.EMPLOYEE in the backend
          firstNameEn: selectedEmployee.firstNameEn || '',
          middleNameEn: selectedEmployee.middleNameEn || '',
          lastNameEn: selectedEmployee.lastNameEn || '',
          nameEn: selectedEmployee.nameEn || `${selectedEmployee.firstNameEn || ''} ${selectedEmployee.lastNameEn || ''}`.trim(),
          gender: selectedEmployee.gender || 'MALE', // Default to MALE if not specified
          // Include additional fields if available
          dob: selectedEmployee.dob || selectedEmployee.dateOfBirth ||null,
          passportNumber: selectedEmployee.passportNumber || '',
          email: selectedEmployee.email || '',
          mobileNumber: selectedEmployee.mobileNumber || ''
        };
        
        console.log("Linking employee UID with uidDetails for backward compatibility:", values.uidDetails);
      }
      
      // Add customerName and customerId for backward compatibility
      // These fields are required by the backend for historical reasons
      if (!values.customerName) {
        values.customerName = employeeDataForSubmission.nameEn;
        console.log("Adding customerName for backward compatibility:", values.customerName);
      }
      
      // Only set customerId if it's a valid UUID
      // The backend expects customerId to be a UUID, not an employee UID string
      if (!values.customerId) {
        // Check if we have a valid UUID
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        
        // Don't set customerId if it's not a valid UUID
        // Instead, we'll use employeeUid which is already set above
        console.log("Not setting customerId as it requires a valid UUID format");
        
        // Remove customerId from validation requirements
        delete values.customerId;
      }
    } else {
      // No employee selected - this is an error condition
      console.error("No employee selected for ticket creation");
      dispatch(showErroMessage("Please select an employee for this ticket."));
      dispatch(dismissLoader());
      return;
    }

    // Final payload validation before submission
    const validatePayload = () => {
      const validationErrors = [];

      // Enhanced employee UID validation
      if (!values.employeeUid && (!values.employee || !values.employee.uid)) {
        validationErrors.push('Employee UID is missing');
        console.error('Employee UID validation failed:', {
          employeeUid: values.employeeUid,
          employeeFromObject: values.employee?.uid,
          selectedEmployee: selectedEmployee?.uid
        });
      }

      // We don't require customerId anymore since it needs to be a UUID
      // Instead, we're using employeeUid which is already validated above
      if (!values.customerName) validationErrors.push('Customer Name is missing');

      // Use our enhanced document validation
      const documentValidation = validateRequiredDocuments(values);
      if (!documentValidation.isValid) {
        // Format missing documents for error message
        const missingDocsList = documentValidation.missingDocuments.join(', ');
        validationErrors.push(`Required documents are missing: ${missingDocsList}`);

        // Log detailed information about missing documents
        console.log('Document validation failed:', {
          missingDocuments: documentValidation.missingDocuments,
          requiredDocuments: documentRequired || [],
          documentIds: values.documentIds || [],
          timestamp: new Date().toISOString()
        });
      } else {
        console.log('Document validation passed:', {
          documentCount: values.documentIds ? values.documentIds.length : 0,
          timestamp: new Date().toISOString()
        });
      }

      return validationErrors;
    };

// Run validation
const validationErrors = validatePayload();
if (validationErrors.length > 0) {
  console.error('Payload validation failed:', validationErrors);
  dispatch(showErroMessage(`Validation failed: ${validationErrors.join(', ')}`));
  dispatch(dismissLoader());
  return;
}

// Sanitize the payload to ensure all fields conform to expected types
const sanitizePayload = (vals) => {
  const sanitized = { ...vals };
  const uuidKeyRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i; // generic UUID for keys
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i; // strict v1-v5 for values

  // Fields that must be UUIDs
  const uuidFields = ['serviceId', 'customerId', 'workflowInstanceId', 'workflowStepId', 'workflowRequestId'];

  // Check and sanitize UUID fields
  uuidFields.forEach((field) => {
    if (sanitized[field] && !uuidKeyRegex.test(sanitized[field])) {
      console.warn(`Field ${field} is not a valid UUID: ${sanitized[field]}. Removing from payload.`);
      delete sanitized[field];
    }
  });

  // Ensure fields object only has UUID keys
  if (sanitized.fields && typeof sanitized.fields === 'object') {
    const validFields = {};
    Object.keys(sanitized.fields).forEach((key) => {
      if (uuidKeyRegex.test(key)) {
        validFields[key] = sanitized.fields[key];
      } else {
        console.warn(`Removing non-UUID key from fields: ${key}`);
      }
    });
    sanitized.fields = validFields;
  }

  // Track document metadata to include in the payload
  // Start with any pre-collected metadata on the values (from grouped docs handling)
  let documentMetadata = Array.isArray(vals.documentMetadata) ? [...vals.documentMetadata] : [];
  // Start with any pre-collected document references
  let aggregatedDocumentReferences = Array.isArray(vals.documentReferences) ? [...vals.documentReferences] : [];

  // Remove legacy static document fields from top-level payload and avoid adding them to documentIds
  const documentFields = [
    'passportCopy',
    'visaPage',
    'birthCertificate',
    'salaryCertificate',
    'labourContract',
    'photo',
    'shinasnama',
  ];

  documentFields.forEach((field) => {
    if (!sanitized[field]) return;

    // Regardless of type, remove static document field from top-level
    // We do NOT use per-document IDs for employee static docs anymore
    console.warn(`Removing legacy static document field from payload: ${field}`);
    delete sanitized[field];
  });

  // Ensure documentIds array exists, but DO NOT auto-populate with static doc IDs
  if (!sanitized.documentIds) sanitized.documentIds = [];

  // If employee flow (employeeUid present), we rely on documentReferences (group-based) for static docs
  // Keep documentIds only if explicitly set elsewhere for non-employee contexts
  if (sanitized.employeeUid) {
    // For employee-based tickets, we only use group-based documentReferences
    sanitized.documentIds = [];
    // Remove legacy metadata to avoid confusion in preview and payload
    if (sanitized.documentMetadata) delete sanitized.documentMetadata;
  }

  // Preserve group-based documentReferences for employee tickets
  if (sanitized.employeeUid) {
    const incomingRefs = Array.isArray(vals.documentReferences) ? vals.documentReferences : [];
    sanitized.documentReferences = incomingRefs
      .filter((ref) => ref && ref.documentGroupId)
      .map((ref) => ({
        documentGroupId: ref.documentGroupId,
        documentType: ref.documentType,
      }));
  } else {
    // Legacy: build from aggregated list for non-employee contexts
    const seenRefs = new Set();
    sanitized.documentReferences = aggregatedDocumentReferences.filter((ref) => {
      const key = `${ref.documentId}::${ref.fieldName}`;
      if (!ref.documentId || seenRefs.has(key)) return false;
      seenRefs.add(key);
      return true;
    });
  }

  return sanitized;
};
    
    // Apply sanitization to the payload
    const sanitizedValues = sanitizePayload(values);
    
    // Log the sanitized request payload for debugging
    console.log('Sanitized ticket creation payload:', {
      timestamp: new Date().toISOString(),
      endpoint: '/v1/ticket',
      method: 'POST',
      customerUid: sanitizedValues.uid,
      customerId: sanitizedValues.customerId,
      customerName: sanitizedValues.customerName,
      isNewCustomer: sanitizedValues.isNewCustomer,
      serviceId: sanitizedValues.serviceId,
      employeeAssignment: sanitizedValues.employeeId ? {
        employeeId: sanitizedValues.employeeId,
        employeeUid: sanitizedValues.employeeUid,
        employeeData: sanitizedValues.employee
      } : null,
      documentIds: sanitizedValues.documentIds,
      documentReferences: sanitizedValues.documentReferences || [],
      documentCount: sanitizedValues.documentCount || 0,
      uidDetails: sanitizedValues.uidDetails
    });
    
    // Verify document fields are properly formatted as strings
    console.log('Document field types check:', {
      birthCertificate: {
        value: values.birthCertificate,
        type: typeof values.birthCertificate
      },
      passportCopy: {
        value: values.passportCopy,
        type: typeof values.passportCopy
      },
      visaPage: {
        value: values.visaPage,
        type: typeof values.visaPage
      },
      photo: {
        value: values.photo,
        type: typeof values.photo
      },
      emiratesId: {
        value: values.emiratesId,
        type: typeof values.emiratesId
      }
    });
    
    // Submit directly without showing preview dialog
    dispatch(showLoader());
    AppService.post("v1/ticket", sanitizedValues)
      .then((response) => {
        console.log("Ticket creation successful:", response);
        console.log('Ticket created successfully:', {
          timestamp: new Date().toISOString(),
          ticketId: response.id || response.ticketId,
          ticketNumber: response.ticketNumber,
          employeeId: sanitizedValues.employeeId,
          employeeUid: sanitizedValues.employeeUid || sanitizedValues.employee?.uid,
          documentCount: sanitizedValues.documentIds?.length || 0,
          documentReferencesCount: sanitizedValues.documentReferences?.length || 0,
          responseData: response
        });
        resetForm?.();
        setFields([]);
        setChargeMapping();
        uidReady(false);
        setUid("");
        const successMessage = `Ticket created successfully! Ticket Number: ${response.ticketNumber || 'N/A'}`;
        dispatch(showSuccessMessage(successMessage));
      })
      .catch((error) => {
        console.error("Error creating ticket:", error);
        let errorMessage = 'Failed to create ticket. Please try again.';
        let errorDetails = {};
        if (error.response) {
          errorDetails = {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data,
            timestamp: new Date().toISOString(),
            endpoint: '/v1/ticket',
            requestPayload: {
              employeeId: sanitizedValues.employeeId,
              employeeUid: sanitizedValues.employee?.uid || sanitizedValues.employeeUid,
              documentIds: sanitizedValues.documentIds,
              serviceId: sanitizedValues.serviceId
            }
          };
          console.error('Error response details:', errorDetails);
          if (error.response.status === 400) {
            errorMessage = 'Invalid ticket data. Please check your inputs and try again.';
            if (error.response.data && error.response.data.errors) {
              const fieldErrors = error.response.data.errors
                .map(err => `${err.field}: ${err.message}`)
                .join(', ');
              errorMessage = `Validation errors: ${fieldErrors}`;
            }
          } else if (error.response.status === 401 || error.response.status === 403) {
            errorMessage = 'Authentication error. Please log in again.';
          } else if (error.response.status === 404) {
            errorMessage = 'Service endpoint not found. Please contact support.';
          } else if (error.response.status === 500) {
            if (error.response.data && error.response.data.message) {
              if (error.response.data.message.includes('UID')) {
                errorMessage = 'Error with customer or employee UID. Please verify and try again.';
              } else if (error.response.data.message.includes('document')) {
                errorMessage = 'Error with document references. Please check document uploads.';
              } else {
                errorMessage = `Server error: ${error.response.data.message}`;
              }
            } else {
              errorMessage = 'Server error occurred. Technical team has been notified.';
            }
          }
        } else if (error.request) {
          console.error('No response received from server', error.request);
          errorMessage = 'No response from server. Please check your network and try again.';
        } else {
          console.error('Error setting up request', error.message);
          errorMessage = `Error setting up request: ${error.message}`;
        }
        dispatch(showErroMessage(errorMessage));
      })
      .finally(() => {
        dispatch(dismissLoader());
      });
    return;
  };

  // Add event listeners for customer not found events and force open dialog events
  useEffect(() => {
    const handleCustomerNotFoundEvent = (event) => {
      const { uid } = event.detail;
      console.log("Customer not found event received for UID:", uid);
      handleCustomerNotFound(uid);
    };
    
    const handleForceOpenCustomerDialogEvent = (event) => {
      console.log("forceOpenCustomerDialog event received", event.detail);
      // Force open the dialog with the UID from the event
      const uidFromEvent = event.detail?.uid || uid;
      
      // Update the new customer data
      setNewCustomer(prev => ({
        ...prev,
        uid: uidFromEvent
      }));
      
      // Force open the dialog
      console.log("Forcing dialog open from event handler");
      setOpenCustomerDialog(true);
    };
    
    // Add event listeners
    window.addEventListener('customerNotFound', handleCustomerNotFoundEvent);
    window.addEventListener('forceOpenCustomerDialog', handleForceOpenCustomerDialogEvent);
    
    // Clean up
    return () => {
      window.removeEventListener('customerNotFound', handleCustomerNotFoundEvent);
      window.removeEventListener('forceOpenCustomerDialog', handleForceOpenCustomerDialogEvent);
    };
  }, [uid]);

  useEffect(() => {
    // Fetch services and service groups in parallel
    Promise.all([
      AppService.get("v1/serviceMapping/mappedServices", { params: { targetType: 'EMPLOYEE' } }),
      AppService.get("v1/serviceGroup").catch(() => []) // Service groups for icons (optional)
    ]).then(([servicesResponse, groupsResponse]) => {
      setServices(servicesResponse);
      setServiceGroups(groupsResponse || []);
    });
  }, []);

  useEffect(() => {
    const fetchTicketAssignPermission = async () => {
      try {
        const token = getAuthToken();
        if (!token) {
          setCanTicketSelfAssign(false);
          setTicketAssignedTo("THAKLIS");
          if (formikRef.current) {
            formikRef.current.setFieldValue("assignedTo", "THAKLIS");
          }
          return;
        }

        const res = await fetch(`${API_PATHS.V1}/organization-config`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          setCanTicketSelfAssign(false);
          setTicketAssignedTo("THAKLIS");
          if (formikRef.current) {
            formikRef.current.setFieldValue("assignedTo", "THAKLIS");
          }
          return;
        }

        const data = await res.json();
        const allow = Array.isArray(data) ? data[0]?.allowTicketSelfAssign : data?.allowTicketSelfAssign;
        const canAssign = Boolean(allow);
        setCanTicketSelfAssign(canAssign);
        if (!canAssign) {
          setTicketAssignedTo("THAKLIS");
          if (formikRef.current) {
            formikRef.current.setFieldValue("assignedTo", "THAKLIS");
          }
        }
      } catch (err) {
        console.error("Error checking ticket assign permission:", err);
        setCanTicketSelfAssign(false);
        setTicketAssignedTo("THAKLIS");
        if (formikRef.current) {
          formikRef.current.setFieldValue("assignedTo", "THAKLIS");
        }
      }
    };

    fetchTicketAssignPermission();
  }, []);

  useEffect(() => {
    dispatch(updateScreenTitle("New Ticket"));
    return () => dispatch(updateScreenTitle(""));
  }, []);
  
  // Fetch field categories when the component mounts
  useEffect(() => {
    const fetchFieldCategories = async () => {
      try {
        console.log('NewTicket: Fetching field categories...');
        const categories = await fieldCategoryUtils.getFieldCategories();
        
        // Log the raw response
        console.log('NewTicket: Raw API response for categories:', categories);
        
        if (!categories || !Array.isArray(categories) || categories.length === 0) {
          console.log('NewTicket: Creating default categories from constants');
          const defaultCategories = Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).map(key => ({
            code: key,
            displayName: fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[key] || key,
            displayOrder: Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).indexOf(key)
          }));
          
          console.log('NewTicket: Using default categories:', defaultCategories);
          setFieldCategories(defaultCategories);
        } else {
          console.log('NewTicket: Using API categories:', categories);
          setFieldCategories(categories);
        }
      } catch (error) {
        console.error('Error fetching field categories:', error);
        // Use default categories if API call fails
        const defaultCategories = Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).map(key => ({
          code: key,
          displayName: fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[key] || key,
          displayOrder: Object.keys(fieldCategoryUtils.FIELD_CATEGORIES).indexOf(key)
        }));
        
        console.log('NewTicket: Using fallback default categories after error:', defaultCategories);
        setFieldCategories(defaultCategories);
      }
    };
    
    fetchFieldCategories();
  }, []);
  
  // Monitor dialog state changes
  useEffect(() => {
    console.log("Dialog state changed - openCustomerDialog:", openCustomerDialog);
  }, [openCustomerDialog]);

  // Service selection handler uses the imported utilities
  
  const onServieChange = (event, setFieldValue) => {
    dispatch(showLoader());
    
    // Use our new service selection handler
    handleServiceSelection(
      event,
      setFieldValue,
      setFields,
      setStaticFields,
      setAdditionalInfoRequired,
      setDocumentRequired,
      setChargeMapping,
      services,
      dispatch
    )
    .then(({ fieldStructure, allFields }) => {
      console.log("Field structure created and stored:", fieldStructure);
      console.log("All fields processed:", allFields);
      
      // Apply consistent field categorization to ensure document fields are properly categorized
      const categorizedFields = ensureConsistentFieldCategorization(allFields);
      
      // Set fields in component state
      setFields(categorizedFields);
      
      // Initialize the field structure context with the new structure
      initializeStructure(fieldStructure);
      
      // Set context to DEFAULT when service changes
      updateContext(CONTEXT_TYPES.DEFAULT);
      
      // Reset any employee-specific state
      setSelectedEmployee(null);
    })
    .catch((error) => {
      console.error("Error in service selection:", error);
      dispatch(showErroMessage("Error loading service fields. Please try again."));
    })
    .finally(() => {
      dispatch(dismissLoader());
    });
  };

  // Handler for tile-based service selection (from ServiceSelectionPanel)
  const handleServiceTileSelect = (service, setFieldValue) => {
    // Create a mock event object to reuse existing onServieChange logic
    const mockEvent = {
      target: {
        value: service.id
      }
    };
    onServieChange(mockEvent, setFieldValue);
  };

  const _onTextChange = (text, field, index) => {
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = text;
      }
    });
    setFields(fieldsCopy);
  };

  const _onFileUpload = (fileUrl, field) => {
    console.log(`=== FILE UPLOAD CALLBACK ===`);
    console.log(`Field parameter received:`, field);
    console.log(`Field ID: ${field?.id}, Field Name: ${field?.name}`);
    console.log(`File uploaded for field ${field?.name}:`, {
      fieldId: field?.id,
      fieldName: field?.name,
      documentGroupId: fileUrl?.documentGroupId,
      documentType: fileUrl?.documentType,
      isDocumentReference: fileUrl && typeof fileUrl === 'object' && fileUrl.isReference,
      timestamp: new Date().toISOString()
    });
    
    // Check if this is a document reference object or has documentGroupId from bulk API
    const isDocumentReference = fileUrl && typeof fileUrl === 'object' && fileUrl.isReference;
    const hasDocumentGroupId = fileUrl && typeof fileUrl === 'object' && fileUrl.documentGroupId;
    
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = fileUrl;
        
        // Store documentGroupId on the field for documentReferences collection
        if (hasDocumentGroupId) {
          item.documentGroupId = fileUrl.documentGroupId;
          console.log(`Stored documentGroupId ${fileUrl.documentGroupId} on field ${item.name}`);
        }
        
        // If this is a document reference, add employee UID context
        if ((isDocumentReference || hasDocumentGroupId) && selectedEmployee && selectedEmployee.uid) {
          // Ensure the document reference has the employee UID
          if (!fileUrl.employeeUid && selectedEmployee.uid) {
            fileUrl.employeeUid = selectedEmployee.uid;
            console.log(`Added employee UID ${selectedEmployee.uid} to document reference`);
          }
          
          // Add document type if missing
          if (!fileUrl.documentType && item.name) {
            // Convert camelCase to snake_case for backend compatibility
            const documentType = item.name.replace(/([A-Z])/g, '_$1').toLowerCase();
            fileUrl.documentType = documentType;
            console.log(`Added document type ${documentType} to document reference`);
          }
        }
      }
    });
    
    setFields(fieldsCopy);
    
    // If this has documentGroupId or is a document reference, also update the form values directly
    if ((isDocumentReference || hasDocumentGroupId) && formikRef.current) {
      formikRef.current.setFieldValue(field.name, fileUrl);
      console.log(`Updated form field ${field.name} with document reference/metadata`);
    }
  };

  const _onFileRemove = (field) => {
    console.log(`Removing file for field ${field.name}`);
    
    // Get the current field value before removing
    let currentValue = null;
    fields.forEach(item => {
      if (item.id === field.id) {
        currentValue = item.value;
      }
    });
    
    const isDocumentReference = currentValue && typeof currentValue === 'object' && currentValue.isReference;
    
    // Log detailed information about the removed file/document
    console.log('File removal details:', {
      fieldId: field.id,
      fieldName: field.name,
      isDocumentReference: isDocumentReference,
      documentId: isDocumentReference ? currentValue.id : null,
      employeeUid: isDocumentReference ? currentValue.employeeUid : null,
      timestamp: new Date().toISOString()
    });
    
    // Update the fields state
    let fieldsCopy = [...fields];
    fieldsCopy.forEach((item) => {
      if (item.id === field.id) {
        item.value = null;
      }
    });
    setFields(fieldsCopy);
    
    // Also clear the form field value if using Formik
    if (formikRef.current) {
      formikRef.current.setFieldValue(field.name, null);
    }
    
    // Remove from populated fields set if applicable
    if (field.name) {
      setPopulatedFields(prev => {
        const newSet = new Set(prev);
        newSet.delete(field.name);
        return newSet;
      });
    }
  };
  
  const _isFieldsAreValid = () => {
    // Check if any mandatory fields are missing values
    const missingMandatoryFields = fields.filter(field => field.mandatory && !field.value);
    
    if (missingMandatoryFields.length > 0) {
      console.log('Missing mandatory fields:', missingMandatoryFields.map(f => f.name));
      return false;
    }
    
    return true;
  };
  
  // Validate document fields specifically
  const validateRequiredDocuments = (values) => {
    // Document fields that are commonly required
    const criticalDocumentFields = [
      'passportCopy',
      'visaPage',
      'emiratesId'
    ];
    
    // Check if we have document requirements from the service
    const requiredDocuments = documentRequired || [];
    
    // Combine service-specific requirements with critical documents
    const allRequiredDocuments = [...new Set([...requiredDocuments, ...criticalDocumentFields])];
    
    // Find fields that match our required documents
    const documentFieldsToCheck = fields.filter(field => 
      allRequiredDocuments.includes(field.name) && field.type === 'FILE'
    );
    
    // Check if any required document fields are missing
    const missingDocuments = documentFieldsToCheck.filter(field => {
      // Get the field value from form values or field state
      const fieldValue = values[field.name] || field.value;
      
      // Check if the field has a value and if it's a document reference
      const hasValidDocument = fieldValue && 
        ((typeof fieldValue === 'object' && fieldValue.isReference && fieldValue.id) || 
         (typeof fieldValue === 'string' && fieldValue.trim() !== ''));
      
      return !hasValidDocument;
    });
    
    if (missingDocuments.length > 0) {
      console.log('Missing required documents:', missingDocuments.map(f => f.name));
      return {
        isValid: false,
        missingDocuments: missingDocuments.map(f => f.label || f.name)
      };
    }
    
    return { isValid: true, missingDocuments: [] };
  };

  // Custom field renderer for CategorizedFields component
  const _renderField = (field, index) => {
    // Skip rendering if field is missing essential properties or is empty
    if (!field || !field.name || field.name === 'undefined' || field.name === 'null') {
      return null;
    }
    
    // Debug log to see field properties
    console.log('%c RENDERING FIELD ', 'background: #ff9800; color: white; font-weight: bold; padding: 2px 4px;', {
      name: field.name,
      label: field.label,
      title: field.title,
      type: field.type,
      category: field.category,
      isServiceField: field.isServiceField
    });
    
    // Ensure we have a proper label for the field
    // Priority: label > title > name (but make name more user-friendly)
    let fieldLabel = field.label || field.title;
    if (!fieldLabel) {
      // If no label or title, try to make the name more user-friendly
      if (field.name && typeof field.name === 'string') {
        // Check if it's a UUID pattern
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (uuidPattern.test(field.name)) {
          // For UUID names, use a generic label or try to get from service field mapping
          fieldLabel = field.displayName || field.fieldName || `Service Field ${index + 1}`;
        } else {
          // For non-UUID names, convert camelCase/snake_case to readable format
          fieldLabel = field.name
            .replace(/([A-Z])/g, ' $1') // Add space before capital letters
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
            .trim();
        }
      } else {
        fieldLabel = `Field ${index + 1}`;
      }
    }
    
    // Update the field object with the computed label
    const enhancedField = {
      ...field,
      label: fieldLabel,
      title: fieldLabel // Also set title for consistency
    };
    
    console.log('%c ENHANCED FIELD LABEL ', 'background: #4caf50; color: white; font-weight: bold; padding: 2px 4px;', {
      originalName: field.name,
      originalLabel: field.label,
      originalTitle: field.title,
      computedLabel: fieldLabel
    });
    
    // Skip fields that are likely to be empty or redundant
    if (field.label && (
        field.label.includes('undefined') || 
        field.label.includes('null') ||
        field.label.trim() === ''
    )) {
      return null;
    }
    
    // Check if this is a document field
    const isDocField = isDocumentField(field);
    
    console.log(`=== RENDER DEBUG: Field ${field.name} - type: ${field.type}, isDocField: ${isDocField}, STAT_FIELDS type: ${STAT_FIELDS[field.name]?.type}`);
    
    // NOTE: This used to skip a document field once its URL had been "processed", tracking it via
    // setState *during render*. That caused a dynamic document field (e.g. "Approval Document") to
    // disappear on the re-render triggered right after its own upload. Each field in `fields` is
    // distinct and static document fields are already excluded from the categorized display, so there
    // is nothing to de-duplicate here — always render the field.
    
    // Use STAT_FIELDS configuration to determine the correct field type for rendering
    const correctFieldType = STAT_FIELDS[field.name]?.type || field.type;
    // A dynamic field is a date field when its type is DATE, or (matching the New Workflow Request
    // form's heuristic) when its label/name reads like a date — many services return date fields as
    // plain TEXT, so the name is the only signal. Word-boundary match avoids "update"/"mandate".
    const _typeU = String(correctFieldType || '').toUpperCase();
    const _dateHint = `${fieldLabel || ''} ${enhancedField.title || ''} ${enhancedField.name || ''} ${enhancedField.code || ''}`
      .replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    const isDateField = _typeU === 'DATE'
      || (!['FILE', 'PDF', 'DOCUMENT', 'IMAGE'].includes(_typeU) && !_dateHint.includes('number') && /\bdate\b/.test(_dateHint));
    const shouldRenderAsText = correctFieldType === "TEXT" || correctFieldType === "NUMBER" || correctFieldType === "PHONE";
    
    console.log(`=== RENDER TYPE DEBUG: Field ${field.name} - originalType: ${field.type}, correctType: ${correctFieldType}, shouldRenderAsText: ${shouldRenderAsText}`);
    
    if (correctFieldType === "SELECT" && field.name === "medicalLocation") {
      return (
        <Grid item xs={12} sm={12} md={6} key={`field-${enhancedField.id}-${index}`}>
          <WDBox height="100%" sx={{ marginBottom: '16px' }}>
            <FormControl fullWidth size="small">
              <InputLabel id="medical-location-select-label">Medical Location</InputLabel>
              <Select
                labelId="medical-location-select-label"
                name="medicalLocation"
                label="Medical Location"
                value={enhancedField.value || MEDICAL_LOCATIONS[0]}
                onChange={(e) => {
                  _onTextChange(e.target.value, enhancedField, index);
                  formikRef.current.setFieldValue("medicalLocation", e.target.value);
                }}
                fullWidth
              >
                {MEDICAL_LOCATIONS.map((loc) => (
                  <MenuItem key={loc} value={loc}>{loc}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </WDBox>
        </Grid>
      );
    }

    if (isDateField) {
      return (
        <Grid item xs={12} sm={12} md={6} key={`field-${enhancedField.id}-${index}`}>
          <WDBox height="100%" sx={{ marginBottom: '16px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label={fieldLabel}
                format="DD-MM-YYYY"
                value={enhancedField.value ? dayjs(enhancedField.value) : null}
                onChange={(newValue) => {
                  const d = newValue ? dayjs(newValue) : null;
                  _onTextChange(d && d.isValid() ? d.format("YYYY-MM-DD") : "", enhancedField, index);
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    required: !!(enhancedField.mandatory || enhancedField.required),
                  },
                }}
              />
            </LocalizationProvider>
          </WDBox>
        </Grid>
      );
    }

    if (shouldRenderAsText) {
      return (
        <Grid item xs={12} sm={12} md={6} key={`field-${enhancedField.id}-${index}`}>
          <WDBox height="100%" sx={{ marginBottom: '16px' }}>
            <FieldText index={index} field={enhancedField} onChange={_onTextChange} contextProps={fieldStructureContext} />
          </WDBox>
        </Grid>
      );
    } else {
      return (
        <Grid item xs={12} sm={12} md={6} key={`field-${enhancedField.id}-${index}`}>
          <WDBox height="100%" sx={{ marginBottom: '16px' }}>
            <FileField
              index={index}
              field={enhancedField}
              onFileUpload={_onFileUpload}
              onFileRemove={_onFileRemove}
              isProcessed={isDocumentFieldProcessed(enhancedField.name)}
              employeeUid={selectedEmployee?.uid || selectedEmployee?.employeeId || ''}
              selectedEmployee={selectedEmployee} // Pass the full employee object
              contextProps={fieldStructureContext}
              deferBulkUpload
            />
          </WDBox>
        </Grid>
      );
    }
  };

  const dateFields = ["dob", "passportExpiry", "emiratesIdIssueDate", "emiratesIdExpiryDate", "visaIssueDate", "visaExpiryDate"];
  // Global variables for application state
  window.showCustomerNotFoundDialog = false;
  window.customerUidNotFound = "";
  window.currentEmployeeUid = ""; // Global variable to store the current employee UID
  
  // Function to handle customer not found - separated for clarity and reliability
  const handleCustomerNotFound = (uidValue) => {
    console.log("HANDLING CUSTOMER NOT FOUND FOR UID:", uidValue);
    
    // Check if this UID looks like a UUID (employee ID)
    const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(uidValue);
    
    if (isUuid) {
      // This might be an employee ID - try to register it as a customer
      dispatch(showLoader("Checking if this is an employee ID..."));
      
      // First, check if this employee can be registered
      AppService.makeAPICall(`/api/employees/check-customer-registration/${uidValue}`, 'GET')
        .then(response => {
          if (response?.data?.success) {
            const isRegistered = response.data.data;
            
            if (isRegistered) {
              // Employee is already registered, try the customer lookup again
              dispatch(showLoader("Employee already registered, retrying lookup..."));
              _getUidDetails();
            } else {
              // Employee is not registered, register them now
              dispatch(showLoader("Registering employee as customer..."));
              return AppService.makeAPICall(`/api/employees/register-as-customer/${uidValue}`, 'POST');
            }
          } else {
            throw new Error("Failed to check employee registration status");
          }
        })
        .then(response => {
          if (response?.data?.success) {
            // Successfully registered employee as customer
            dispatch(showSuccessMessage("Employee successfully registered as a customer"));
            // Now try the customer lookup again
            _getUidDetails();
          }
        })
        .catch(error => {
          console.error("Error registering employee as customer:", error);
          // Fall back to manual customer creation
          dispatch(showErroMessage(`Could not register employee as customer. Please add customer details manually.`));
          
          // Initialize new customer data
          const newCustomerData = {
            uid: uidValue,
            firstNameEn: "",
            middleNameEn: "",
            lastNameEn: "",
            nameEn: "",
            mobileNumber: "",
            email: ""
          };
          
          // Update state with new customer data
          setNewCustomer(newCustomerData);
          
          // Reset form but keep UID
          if (formikRef.current) {
            formikRef.current.resetForm();
            formikRef.current.setFieldValue("uid", uidValue);
          }
        })
        .finally(() => {
          dispatch(dismissLoader());
        });
    } else {
      // Not a UUID, proceed with normal customer creation
      dispatch(showErroMessage(`Customer with UID ${uidValue} not found. Please add customer details.`));
      
      // Initialize new customer data
      const newCustomerData = {
        uid: uidValue,
        firstNameEn: "",
        middleNameEn: "",
        lastNameEn: "",
        nameEn: "",
        mobileNumber: "",
        email: ""
      };
      
      // Update state with new customer data
      setNewCustomer(newCustomerData);
      
      // Reset form but keep UID
      if (formikRef.current) {
        formikRef.current.resetForm();
        formikRef.current.setFieldValue("uid", uidValue);
      }
    }
    uidReady(false);
    
    // Force close any existing dialog first to ensure clean state
    setOpenCustomerDialog(false);
    
    // Important: Use setTimeout with a small delay to ensure the dialog opens reliably
    // This helps avoid race conditions with React state updates
    setTimeout(() => {
      console.log("Opening customer dialog with setOpenCustomerDialog");
      setOpenCustomerDialog(true);
      
      // Additional check to ensure dialog opens
      setTimeout(() => {
        if (!openCustomerDialog) {
          console.log("Dialog not opened after first attempt, trying again");
          setOpenCustomerDialog(true);
        }
      }, 300);
    }, 100);
    
    // Log the current state of the dialog
    console.log("Customer not found handler completed - dialog state:", openCustomerDialog);
    
    // Dispatch a custom event to ensure the dialog opens
    // This is a backup mechanism in case the state updates don't trigger properly
    window.dispatchEvent(new CustomEvent('forceOpenCustomerDialog', { detail: { uid: uidValue } }));
  };
  
  const _getUidDetails = () => {
    // Get the UID from state instead of formikRef
    const uidValue = uid.trim();
    console.log("_getUidDetails called for UID:", uidValue);
    
    // Validate UID is provided
    if (!uidValue) {
      console.log("UID validation failed: uid is empty or only whitespace");
      dispatch(showErroMessage("Please Enter valid UID"));
      return;
    }
    
    // Set the UID in formikRef for consistency
    formikRef.current.setFieldValue("uid", uidValue);
    
    console.log("UID validation passed, making API call for UID:", uidValue);
    dispatch(showLoader());
    
    // Use the authenticated API endpoint
    console.log("Making API call to api/customers/lookup with UID:", uidValue);
    
    // Add auth token from AppService - ensure we're using the correct authenticated endpoint
    AppService.get("/api/customers/lookup", { params: { uid: uidValue } })
      .then((response) => {
        try {
          console.log("Populating form fields with customer data");
          console.log("Response structure:", response);
          
          // The AppService interceptor already extracts the data for us
          // so response is already the data object
          const customerData = response;
          
          // First, ensure we have a valid UID from the response or the search value
          const validUid = customerData.uid || uidValue;
          
          if (!validUid || validUid.trim() === '') {
            console.error("No valid UID found in customer data or search");
            throw new Error("No valid UID found in customer data");
          }
          
          // Update the UID state with the validated UID
          console.log("Setting UID state with validated UID:", validUid);
          setUid(validUid);
          
          // Ensure the UID is also set in the form values
          if (formikRef.current) {
            formikRef.current.setFieldValue("uid", validUid);
            console.log("UID set in form values:", validUid);
          }
          
          // Mark UID as ready
          console.log("Marking UID as ready:", validUid);
          uidReady(true);
          
          // Use setTimeout to ensure state updates have time to propagate
          setTimeout(() => {
            try {
              // Track which fields we're populating
              const populatedFieldsSet = new Set();
              
              // Only process fields that are actually in the form
              // This prevents errors from trying to set fields that don't exist
              if (formikRef.current) {
                // Log available customer data fields for debugging
                console.log("Available customer data fields:", Object.keys(customerData));
                
                // Set basic customer fields
                formikRef.current.setFieldValue("uid", customerData.uid || "");
                populatedFieldsSet.add("uid");
                
                // For name fields, try different possible formats
                const customerName = customerData.nameEn || 
                  customerData.name || 
                  `${customerData.firstNameEn || ''} ${customerData.middleNameEn ? customerData.middleNameEn + ' ' : ''}${customerData.lastNameEn || ''}`;
                
                console.log("Computed customer name:", customerName);
                formikRef.current.setFieldValue("customerName", customerName.trim());
                populatedFieldsSet.add("customerName");
                populatedFieldsSet.add("firstNameEn");
                populatedFieldsSet.add("nameEn");
                
                // For ID, try different possible field names
                const customerId = customerData.id || customerData.customerId || customerData.customer_id || '';
                console.log("Computed customer ID:", customerId);
                formikRef.current.setFieldValue("customerId", customerId);
                populatedFieldsSet.add("customerId");
                
                // For mobile/phone, try different possible field names
                const mobile = customerData.mobileNumber || customerData.mobile || customerData.phone || customerData.phoneNumber || '';
                console.log("Computed mobile:", mobile);
                formikRef.current.setFieldValue("mobileNumber", mobile);
                populatedFieldsSet.add("mobileNumber");
                populatedFieldsSet.add("phone");
                populatedFieldsSet.add("phoneNumber");
                populatedFieldsSet.add("mobile");
                
                // For email, try different possible field names
                const email = customerData.email || customerData.emailAddress || customerData.email_address || '';
                console.log("Computed email:", email);
                formikRef.current.setFieldValue("email", email);
                populatedFieldsSet.add("email");
                populatedFieldsSet.add("emailAddress");
                
                // Set other fields if they exist in the form
                const fieldsToSet = [
                  "firstNameEn", "middleNameEn", "lastNameEn", "nameEn",
                  "gender", "passportNumber", "emiratesId", "birthCertificate"
                ];
                
                fieldsToSet.forEach(field => {
                  if (formikRef.current.values.hasOwnProperty(field) && customerData[field]) {
                    formikRef.current.setFieldValue(field, customerData[field] || "");
                    populatedFieldsSet.add(field);
                    
                    // Also add common variations of the field name
                    if (field === "firstNameEn") {
                      populatedFieldsSet.add("firstName");
                      populatedFieldsSet.add("first_name");
                    } else if (field === "middleNameEn") {
                      populatedFieldsSet.add("middleName");
                      populatedFieldsSet.add("middle_name");
                    } else if (field === "lastNameEn") {
                      populatedFieldsSet.add("lastName");
                      populatedFieldsSet.add("last_name");
                    } else if (field === "gender") {
                      populatedFieldsSet.add("sex");
                    } else if (field === "birthCertificate") {
                      populatedFieldsSet.add("birth_certificate");
                    }
                  }
                });
                
                // Handle date fields separately with better error handling
                dateFields.forEach(dateField => {
                  try {
                    if (customerData[dateField] && formikRef.current.values.hasOwnProperty(dateField)) {
                      formikRef.current.setFieldValue(
                        dateField,
                        dayjs.utc(customerData[dateField], "YYYY-MM-DD").local()
                      );
                      populatedFieldsSet.add(dateField);
                    }
                  } catch (dateError) {
                    console.error(`Error setting date field ${dateField}:`, dateError);
                  }
                });
                
                // Log form values after update
                console.log("Current form values after update:", formikRef.current.values);
                
                // Update state with the set of populated fields
                setPopulatedFields(populatedFieldsSet);
              }
              
              // Set UID ready flag to true
              console.log("Setting uidReady to true");
              uidReady(true);
              
              // Show success message
              dispatch(showSuccessMessage("Customer details loaded successfully"));
            } catch (formError) {
              console.error("Error setting form values:", formError);
              dispatch(showErroMessage("Error populating form fields. Please try again."));
            } finally {
              // Always dismiss loader
              dispatch(dismissLoader());
            }
          }, 100);
        } catch (stateError) {
          console.error("Error updating state:", stateError);
          dispatch(showErroMessage("An unexpected error occurred. Please try again."));
          dispatch(dismissLoader());
        }
      })
      .catch((error) => {
        console.error("Error fetching UID details:", error);
        console.log("Error details:", {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
          message: error.message,
          code: error.code
        });
        
        try {
          console.log("Analyzing error response:", error);
          
          // For string errors, we need to check the string content directly
          const errorString = typeof error === 'string' ? error : JSON.stringify(error);
          
          // Check for all possible ways to detect a "customer not found" error
          const isNotFoundError = 
            // Check string error content
            errorString.includes("not found") || 
            errorString.includes("404") ||
            // Check error object properties
            error?.message?.includes("404") || 
            error?.code === "ERR_BAD_REQUEST" || 
            error?.response?.status === 404 || 
            (error?.response?.data?.code === "not_found") ||
            (typeof error?.response?.data === 'object' && error?.response?.data?.message?.includes("not found"));
          
          if (isNotFoundError) {
            console.log("Customer not found detected, showing creation dialog");
            console.log("Current UID value being passed to handleCustomerNotFound:", uidValue);
            
            // Call the handleCustomerNotFound function with the current UID
            handleCustomerNotFound(uidValue);
          } else if (error.response) {
            const status = error.response.status;
            const errorData = error.response.data;
            
            if (status === 403) {
              // Customer found but belongs to different organization
              console.log("Customer belongs to a different organization");
              dispatch(showErroMessage("This customer belongs to a different organization and cannot be accessed."));
              formikRef.current.setFieldValue("uid", "");
              uidReady(false);
            } else {
              // Other errors
              dispatch(showErroMessage(errorData?.message || "An error occurred while looking up the customer."));
              uidReady(false);
            }
          } else {
            // Network or other errors
            dispatch(showErroMessage("Failed to fetch customer details. Please try again."));
            uidReady(false);
          }
        } catch (handlingError) {
          console.error("Error while handling customer lookup error:", handlingError);
          dispatch(showErroMessage("An unexpected error occurred. Please try again."));
          uidReady(false);
        } finally {
          dispatch(dismissLoader());
        }
      });
  };

  const _onStaticFieldDocUpload = (formikField) => {
    let uploadingStaticDocsCopy = [...uploadingStaticDocs];
    uploadingStaticDocsCopy.push(formikField);
    setUploadingStaticDocs(uploadingStaticDocsCopy);
  };

  const _onStaticFieldDocUploadComplete = (formikField) => {
    let uploadingStaticDocsCopy = [...uploadingStaticDocs].filter((item) => item !== formikField);
    setUploadingStaticDocs(uploadingStaticDocsCopy);
  };

  function onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }
  
  // Handle customer dialog input changes
  const handleCustomerInputChange = (e) => {
    const { name, value } = e.target;
    
    // Update the specific field
    const updatedCustomer = {
      ...newCustomer,
      [name]: value
    };
    
    // If first, middle, or last name changed, auto-update the full name
    if (name === 'firstNameEn' || name === 'middleNameEn' || name === 'lastNameEn') {
      const fullName = [
        name === 'firstNameEn' ? value : updatedCustomer.firstNameEn,
        name === 'middleNameEn' ? value : updatedCustomer.middleNameEn,
        name === 'lastNameEn' ? value : updatedCustomer.lastNameEn
      ].filter(Boolean).join(' ');
      
      updatedCustomer.nameEn = fullName;
    }
    
    setNewCustomer(updatedCustomer);
  };
  
  // Handle customer dialog close
  const handleCloseCustomerDialog = () => {
    setOpenCustomerDialog(false);
  };
  
  // Handle customer creation
  const handleCreateCustomer = () => {
    // Validate required fields
    if (!newCustomer.firstNameEn.trim()) {
      dispatch(showErroMessage("First name is required"));
      return;
    }
    
    if (!newCustomer.lastNameEn.trim()) {
      dispatch(showErroMessage("Last name is required"));
      return;
    }
    
    if (!newCustomer.mobileNumber.trim()) {
      dispatch(showErroMessage("Mobile number is required"));
      return;
    }
    
    // Set isNewCustomer flag in the form to indicate we're creating a new customer
    if (formikRef.current) {
      formikRef.current.setFieldValue("isNewCustomer", true);
      console.log("Set isNewCustomer flag to true in form");
    }
    
    // If nameEn is not provided, generate it from first, middle and last name
    let customerData = { ...newCustomer };
    if (!customerData.nameEn.trim()) {
      const fullName = [
        customerData.firstNameEn.trim(),
        customerData.middleNameEn.trim(),
        customerData.lastNameEn.trim()
      ].filter(Boolean).join(" ");
      
      customerData.nameEn = fullName;
    }
    
    dispatch(showLoader());
    
    console.log("Creating customer with UID:", customerData.uid);
    
    // Call the API to create a new customer
    console.log("Creating customer with data:", customerData);
    AppService.post("/api/customers/create", customerData)
      .then((response) => {
        console.log("Customer created successfully:", response);
        dispatch(showSuccessMessage(`Customer ${customerData.firstNameEn} ${customerData.lastNameEn} created successfully with UID: ${customerData.uid}`));
        
        // Close the dialog
        setOpenCustomerDialog(false);
        
        // Check if response has data property (some APIs wrap the response)
        const customerData = response.data || response;
        
        // Populate form fields with the newly created customer data
        if (customerData) {
          Object.keys(customerData).forEach((uidKey) => {
            if (dateFields.includes(uidKey) && customerData[uidKey]) {
              formikRef.current.setFieldValue(
                uidKey,
                dayjs.utc(customerData[uidKey], "YYYY-MM-DD").local()
              );
            } else if (customerData[uidKey]) {
              formikRef.current.setFieldValue(uidKey, customerData[uidKey]);
            }
          });
          
          // Ensure UID is properly set in both form and state
          const validUid = customerData.uid || newCustomer.uid;
          console.log("Setting UID after customer creation:", validUid);
          
          if (!validUid || validUid.trim() === '') {
            console.error("No valid UID found in created customer data");
            dispatch(showErroMessage("Error: Customer created but no valid UID returned"));
            return;
          }
          
          // Update form value
          formikRef.current.setFieldValue("uid", validUid);
          
          // Update component state
          setUid(validUid);
          console.log("UID state updated after customer creation:", validUid);
          
          // Reset isNewCustomer flag since we now have a valid UID
          formikRef.current.setFieldValue("isNewCustomer", false);
          console.log("Reset isNewCustomer flag after getting valid UID");
        }
        
        // Set UID ready flag to true
        console.log("Marking UID as ready after customer creation");
        uidReady(true);
        
        // Fetch the customer details again to ensure we have all the data
        setTimeout(() => {
          _getUidDetails();
        }, 500);
      })
      .catch((error) => {
        console.error("Error creating customer:", error);
        let errorMessage = "Failed to create customer";
        
        if (error.response) {
          const status = error.response.status;
          const errorData = error.response.data;
          
          if (status === 409) {
            errorMessage = "A customer with this UID already exists";
            // If customer already exists, try to fetch their details
            setTimeout(() => {
              _getUidDetails();
              setOpenCustomerDialog(false);
            }, 1000);
          } else if (status === 403) {
            errorMessage = "You are not authorized to create customers";
          } else if (status === 400) {
            errorMessage = errorData?.message || "Invalid customer data";
          } else {
            errorMessage = errorData?.message || "Server error while creating customer";
          }
        }
        
        dispatch(showErroMessage(errorMessage));
      })
      .finally(() => {
        dispatch(dismissLoader());
      });
  };

  return (
    <LayoutCard>
      <Formik
        initialValues={initialValues}
        onSubmit={_onSubmit}
        validationSchema={validationSchema}
        innerRef={formikRef}
      >
        {({ errors, isValid, touched, dirty, setFieldValue, values, setFieldTouched }) => (
          <Form onKeyDown={onKeyDown}>
            {/* Step Progress Indicator */}
            <StepProgress
              serviceSelected={Boolean(values.serviceId)}
              employeeSelected={Boolean(selectedEmployee)}
              detailsComplete={isUidready && Object.keys(touched).length > 2}
              formValid={dirty && isValid && _isFieldsAreValid()}
            />

            {/* Use fully dynamic form layout with categorized fields */}
            {/* Ticket Information */}
            <Box sx={cardStyle}>
              <Box sx={headerStyle}>
                <WDTypography fontSize={16} variant="h6" color="white">
                  Ticket Information
                </WDTypography>
              </Box>
              <Divider sx={{ borderColor: 'divider' }} />
              <Box sx={cardContentStyle}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <WDBox>
                      <ServiceSelectionPanel
                        services={services}
                        serviceGroups={serviceGroups}
                        selectedServiceId={values.serviceId}
                        onServiceSelect={(service) => handleServiceTileSelect(service, setFieldValue)}
                        showPricing={true}
                      />
                      {Boolean(errors.serviceId) && Boolean(touched.serviceId) && (
                        <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                          {errors.serviceId}
                        </Typography>
                      )}
                    </WDBox>
                  </Grid>
                  {/* Employee search moved to its own section below */}
                </Grid>
              </Box>
            </Box>
            
            {/* Employee Search Section - Sleek Design */}
            <Box sx={cardStyle}>
              <Box sx={headerStyle}>
                <WDTypography fontSize={16} variant="h6" color="white">
                  Employee Search
                </WDTypography>
              </Box>
              <Divider sx={{ borderColor: 'divider' }} />
              {/* Global styles to fix menu font visibility */}
              <style>
                {`
                  /* Fix menu item visibility */
                  .MuiMenuItem-root {
                    color: #000 !important;
                    font-weight: 400 !important;
                  }
                  .MuiAutocomplete-option {
                    color: #000 !important;
                    font-weight: 400 !important;
                  }
                  /* Fix dropdown items */
                  .MuiAutocomplete-listbox .MuiAutocomplete-option {
                    color: #000 !important;
                    font-weight: 400 !important;
                    background-color: #fff;
                  }
                  /* Fix hover state */
                  .MuiAutocomplete-listbox .MuiAutocomplete-option:hover {
                    background-color: rgba(0, 0, 0, 0.04) !important;
                  }
                  /* Fix selected state */
                  .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"] {
                    background-color: rgba(0, 0, 0, 0.08) !important;
                  }
                  /* Ensure text in inputs is visible */
                  .MuiInputBase-input {
                    color: rgba(0, 0, 0, 0.87) !important;
                  }
                `}
              </style>
              <Box sx={cardContentStyle}>
                <Field name="employeeId">
                  {({ field }) => (
                    <Box sx={{ position: 'relative' }}>
                      {/* Show either the search component or the selected employee display */}
                      {!selectedEmployee ? (
                        <Box>
                          {/* Employee search component when no employee is selected */}
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                            <Box sx={{ flex: 1 }}>
                              <QuickEmployeeSearch
                                selectedEmployee={null}
                                onEmployeeSelect={handleEmployeeSelect}
                              />
                            </Box>
                            <Button
                              variant="outlined"
                              onClick={() => setOpenQuickAddEmployee(true)}
                              sx={{
                                minWidth: 'auto',
                                height: '56px',
                                px: 2,
                                borderRadius: '10px',
                                borderColor: '#00838f',
                                color: '#00838f',
                                textTransform: 'none',
                                fontWeight: 600,
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  borderColor: '#00838f',
                                  backgroundColor: 'rgba(0,131,143,0.04)',
                                  boxShadow: '0 0 0 3px rgba(0,131,143,0.1)'
                                }
                              }}
                            >
                              Quick Add
                            </Button>
                          </Box>
                        </Box>
                      ) : (
                        /* Custom Sleek Selected Employee Display when employee is selected */
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          p: 2,
                          borderRadius: '8px',
                          backgroundColor: '#f5f9fc',
                          border: '1px solid #e1f5fe',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        }}>
                          {/* Employee Photo */}
                          <Avatar
                            sx={{
                              width: 40,
                              height: 40,
                              mr: 2,
                              bgcolor: '#00838f',
                              boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                              position: 'relative',
                              overflow: 'hidden'
                            }}
                          >
                            {/* Inline base64 thumbnail first (zero HTTP fetch);
                                fall back to authenticated S3 fetch only when
                                the row predates the inline-thumb feature. */}
                            {selectedEmployee.photoThumbnail ? (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                                <img
                                  src={selectedEmployee.photoThumbnail}
                                  alt={`${selectedEmployee.nameEn || selectedEmployee.firstNameEn || 'Employee'} photo`}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '50%'
                                  }}
                                />
                              </Box>
                            ) : selectedEmployee.photo ? (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  width: '100%',
                                  height: '100%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                                <AuthenticatedImage
                                  src={selectedEmployee.photo}
                                  alt={`${selectedEmployee.nameEn || selectedEmployee.firstNameEn || 'Employee'} photo`}
                                  employeeId={selectedEmployee.uid || selectedEmployee.employeeId || ''}
                                  maxSize={80}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '50%'
                                  }}
                                />
                              </Box>
                            ) : (
                              <MdPerson size={24} />
                            )}
                          </Avatar>
                          
                          {/* Employee Details - Compact Single Row */}
                          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                            <Typography sx={{ fontWeight: 600, fontSize: '0.95rem', color: '#263238' }}>
                              {selectedEmployee.nameEn ||
                               `${selectedEmployee.firstNameEn || ''} ${selectedEmployee.lastNameEn || ''}`}
                            </Typography>
                            {selectedEmployee.employeeId && (
                              <Chip
                                label={selectedEmployee.employeeId}
                                size="small"
                                sx={{
                                  height: 22,
                                  fontSize: 11,
                                  backgroundColor: '#e3f2fd',
                                  color: '#0277bd',
                                  fontWeight: 600,
                                  '& .MuiChip-label': { px: 1 }
                                }}
                              />
                            )}
                            {selectedEmployee.department && (
                              <Typography variant="caption" sx={{ color: '#616161', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <span style={{ color: '#9e9e9e' }}>|</span> {selectedEmployee.department?.departmentName}
                              </Typography>
                            )}
                          </Box>
                          
                          {/* Change Employee Button */}
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={handleEmployeeRemove}
                            sx={{
                              minWidth: 'auto',
                              ml: 1,
                              fontSize: '0.75rem',
                              textTransform: 'none',
                              borderRadius: '4px',
                              py: 0.5,
                              px: 1,
                              color: '#000000',
                              borderColor: '#000000'
                            }}
                          >
                            Change
                          </Button>
                        </Box>
                      )}
                    </Box>
                  )}
                </Field>
              </Box>
            </Box>
            
            {/* Customer fields that are loaded automatically after UID search */}
            {isUidready && (
              <Box sx={secondaryCardStyle}>
                <Box sx={secondaryHeaderStyle}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#424242' }}>
                    Employee Information
                  </Typography>
                </Box>
                <Box sx={{ ...cardContentStyle, backgroundColor: '#fff' }}>
                  <CustomerTextField
                    staticFields={staticFields}
                    isUidready={isUidready}
                    formikRef={formikRef}
                    setFieldValue={setFieldValue}
                    uploadingDocs={uploadingStaticDocs}
                    onUpload={_onStaticFieldDocUpload}
                    onUploadComplete={_onStaticFieldDocUploadComplete}
                    formikValues={values}
                    employeeUid={selectedEmployee?.uid || ''}
                  />
                </Box>
              </Box>
            )}

            {/* Directly implement categorized fields with immediate modern card-based design */}
            {fields.length > 0 && selectedEmployee && selectedEmployee.uid && (
              <Box sx={{ mt: 3 }}>
                {(() => {
                  // Immediately group fields by category to ensure proper display
                  const groupedFields = {};
                  
                  // Ensure Customer Details fields are always present first
                  if (!groupedFields['PERSONAL_INFO']) {
                    groupedFields['PERSONAL_INFO'] = [];
                  }
                  
                  // Define static document fields that should only appear in Customer Information
                  const staticDocumentFields = getStaticDocumentFields();
                  
                  // Process all fields and organize by category
                  // Filter out problematic fields and static document fields from categorized display
                  const validFields = fields.filter(field => {
                    // Skip fields with missing or invalid names/labels
                    if (!field || !field.name || field.name === 'undefined' || field.name === 'null') {
                      return false;
                    }
                    
                    // Skip fields with invalid labels
                    if (field.label && (
                        field.label.includes('undefined') || 
                        field.label.includes('null') ||
                        field.label.trim() === ''
                    )) {
                      return false;
                    }
                    
                    // Skip static document fields from being included in the categorized fields
                    // since they're already shown in the Customer Information section
                    if (staticDocumentFields.includes(field.name)) {
                      console.log(`Filtering out static document field from categorized display: ${field.name}`);
                      return false;
                    }
                    
                    return true;
                  });
                  
                  // Now categorize the valid fields using STATIC_FIELD_CATEGORY_MAP
                  validFields.forEach(field => {
                    // Use STATIC_FIELD_CATEGORY_MAP for consistent categorization
                    const category = STATIC_FIELD_CATEGORY_MAP[field.name] || 'SERVICE_SPECIFIC';
                    
                    // Ensure the category exists in groupedFields
                    if (!groupedFields[category]) {
                      groupedFields[category] = [];
                    }
                    
                    // Add the field to the appropriate category
                    groupedFields[category].push(field);
                    
                    // Log the categorization for debugging
                    console.log(`Field ${field.name} categorized as: ${category}`);
                  });
                  
                  console.log('Direct field categorization completed:', groupedFields);
                  
                  // Use the field categories from state if available, or use defaults
                  // Remove PERSONAL_INFO since we already have Customer Information section
                  const categoryOrder = fieldCategories.length > 0 
                    ? fieldCategories
                        .filter(cat => cat.code !== 'PERSONAL_INFO')
                        .sort((a, b) => a.displayOrder - b.displayOrder)
                        .map(cat => cat.code)
                    : [
                        'CONTACT_INFO',
                        'IDENTIFICATION',
                        'ADDRESS',
                        'DOCUMENTS',
                        'SERVICE_SPECIFIC',
                        'OTHER'
                      ];
                      
                  // Create a mapping for display names using field categories
                  const categoryDisplayNames = {};
                  if (fieldCategories.length > 0) {
                    fieldCategories.forEach(cat => {
                      categoryDisplayNames[cat.code] = cat.displayName;
                    });
                  } else {
                    // Fallback to default display names from fieldCategoryUtils
                    Object.keys(fieldCategoryUtils.CATEGORY_DISPLAY_NAMES).forEach(key => {
                      categoryDisplayNames[key] = fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[key];
                    });
                  }
                  
                  // Sort category keys based on the defined order
                  const sortedCategoryKeys = Object.keys(groupedFields).sort((a, b) => {
                    const indexA = categoryOrder.indexOf(a);
                    const indexB = categoryOrder.indexOf(b);
                    
                    // If both categories are in our order list, use that order
                    if (indexA >= 0 && indexB >= 0) {
                      return indexA - indexB;
                    }
                    
                    // If only one category is in our list, that one comes first
                    if (indexA >= 0) return -1;
                    if (indexB >= 0) return 1;
                    
                    // Otherwise, sort alphabetically
                    return a.localeCompare(b);
                  });
                  
                  // Render each category in a card
                  // Helper function to check if a field is already populated from customer data
                  const isFieldAlreadyPopulated = (field) => {
                    // Only apply this logic if we have customer data loaded (UID is ready)
                    if (!isUidready || !populatedFields.size) {
                      return false;
                    }
                    
                    // Safety check in case field is undefined or missing name
                    if (!field || !field.name) {
                      console.log('Warning: Received invalid field object:', field);
                      return false; // Don't filter out invalid fields, let React handle them
                    }
                    
                    // Skip UUID validation for fields that are clearly UUIDs
                    const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
                    if (uuidPattern.test(field.name)) {
                      console.log(`Field with UUID name detected: ${field.name}, not filtering`);
                      return false; // Don't filter out fields with UUID names
                    }
                    
                    // Direct match by exact field name
                    if (populatedFields.has(field.name)) {
                      console.log(`MATCH FOUND - Direct field name match for: ${field.name}`);
                      return true;
                    }
                    
                    // Log the field we're checking for debugging
                    console.log(`Checking if field is already populated: ${field.name}, Label: ${field.label || 'no label'}`);
                    
                    // Check if the field name is directly in our populated fields list
                    if (populatedFields.has(field.name)) {
                      console.log(`MATCH FOUND - Direct match for field: ${field.name}`);
                      return true;
                    }
                    
                    // Check common variations of field names
                    const normalizedName = field.name
                      .replace(/([A-Z])/g, '_$1').toLowerCase() // Convert camelCase to snake_case
                      .replace(/^_/, '') // Remove leading underscore if present
                      .replace(/_en$/, '')   // Remove _en suffix if present
                      .replace(/^first_name/, 'firstName') // Check common variations
                      .replace(/^middle_name/, 'middleName')
                      .replace(/^last_name/, 'lastName');
                    
                    console.log(`Normalized field name: ${normalizedName}`);
                                            
                    // Check if normalized version is in populated fields
                    if (populatedFields.has(normalizedName)) {
                      console.log(`MATCH FOUND - Normalized match for field: ${field.name} → ${normalizedName}`);
                      return true;
                    }
                    
                    // Also check by label for fields with similar meanings but different names
                    if (field.label) {
                      const normalizedLabel = field.label.toLowerCase()
                        .replace(/\s+/g, '_');  // Convert label to lowercase snake_case
                      
                      console.log(`Normalized label: ${normalizedLabel}`);
                      
                      // More aggressive matching for specific field types
                      if (field.name === 'birthCertificate' || normalizedLabel.includes('birth')) {
                        if (populatedFields.has('birthCertificate')) {
                          console.log(`MATCH FOUND - Birth certificate field matched`);
                          return true;
                        }
                      }
                      
                      if (field.name === 'gender' || normalizedLabel.includes('gender')) {
                        if (populatedFields.has('gender')) {
                          console.log(`MATCH FOUND - Gender field matched`);
                          return true;
                        }
                      }
                      
                      // Check some common field label patterns
                      if (
                        (normalizedLabel.includes('name') && (
                          populatedFields.has('nameEn') || 
                          populatedFields.has('firstNameEn') || 
                          populatedFields.has('customerName')
                        )) ||
                        (normalizedLabel.includes('phone') && (
                          populatedFields.has('mobileNumber') || 
                          populatedFields.has('phone') || 
                          populatedFields.has('phoneNumber')
                        )) ||
                        (normalizedLabel.includes('email') && populatedFields.has('email')) ||
                        (normalizedLabel.includes('gender') && populatedFields.has('gender')) ||
                        (normalizedLabel.includes('birth') && (
                          populatedFields.has('birthCertificate') || 
                          populatedFields.has('dateOfBirth')
                        )) ||
                        (normalizedLabel.includes('passport') && populatedFields.has('passportNumber')) ||
                        (normalizedLabel.includes('emirates') && populatedFields.has('emiratesId'))
                      ) {
                        console.log(`MATCH FOUND - Label pattern match for field: ${field.name}`);
                        return true;
                      }
                    }
                    
                    console.log(`No match found for field: ${field.name}`);
                    return false;
                  };
                  
                  // Log populated fields for debugging
                  console.log('Current populated fields:', Array.from(populatedFields));
                  
                  // If UID data is loaded, remove the PERSONAL_INFO category from groupedFields
                  // This ensures we don't show duplicate personal info since it's already in Customer Information
                  if (isUidready && groupedFields['PERSONAL_INFO']) {
                    console.log('Removing PERSONAL_INFO category entirely since UID data is loaded');
                    delete groupedFields['PERSONAL_INFO'];
                  }
                  
                  // The "Customer Information" section is hardcoded in the UI, not from database categories
                  return sortedCategoryKeys.map(category => {
                    // Safety check for missing category in groupedFields
                    if (!groupedFields[category] || !Array.isArray(groupedFields[category])) {
                      console.log(`Warning: Category ${category} is missing or not an array in groupedFields`);
                      return null;
                    }
                    
                    // For all other categories, filter out fields that were populated from the customer data
                    // Use safe filtering with additional checks for invalid fields
                    const fieldsForCategory = groupedFields[category].filter(field => {
                      // Skip invalid fields instead of trying to process them
                      if (!field || typeof field !== 'object') {
                        console.log(`Warning: Invalid field found in category ${category}:`, field);
                        return false; // Filter out invalid fields
                      }
                      return !isFieldAlreadyPopulated(field);
                    });
                    
                    console.log(`Category ${category} has ${fieldsForCategory.length} fields after filtering`);
                    
                    // Skip rendering if no fields in this category
                    if (!fieldsForCategory || fieldsForCategory.length === 0) {
                      console.log(`Skipping empty category: ${category}`);
                      return null;
                    }
                    
                    // Get display name from field categories, then fall back to our mapping, then utils, then raw category
                    const catFromDB = fieldCategories.find(cat => cat.code === category);
                    const displayName = catFromDB ? catFromDB.displayName : 
                                          (categoryDisplayNames[category] || 
                                           fieldCategoryUtils.CATEGORY_DISPLAY_NAMES[category] || 
                                           category.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()));
                    
                    return (
                      <Box key={category} sx={secondaryCardStyle} mb={2}>
                        <Box sx={secondaryHeaderStyle}>
                          <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#424242' }}>
                            {displayName}
                          </Typography>
                        </Box>
                        <Box sx={{ ...cardContentStyle, backgroundColor: '#fff' }}>
                          <Grid container spacing={2}>
                            {fieldsForCategory.map((field, index) =>
                              _renderField(field, index)
                            )}
                          </Grid>
                        </Box>
                      </Box>
                    );
                  });
                })()} 
              </Box>
            )}

            {chargeMapping && (
              <Box sx={{ ...secondaryCardStyle, mt: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    py: 1.5,
                    px: 2,
                    backgroundColor: '#fff',
                    borderRadius: 1,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontSize: pxToRem(14), fontWeight: "bold" }}
                    >
                      Ticket assignment
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                      <Tooltip
                        title={
                          ticketAssignedTo === "ORGANIZATION"
                            ? `Currently assigned to ${organizationName}: The organization will be responsible for this ticket.`
                            : "Currently assigned to Thaklis: Thaklis staff will handle this ticket."
                        }
                      >
                        <Chip
                          icon={
                            ticketAssignedTo === "ORGANIZATION" ? (
                              <PersonIcon />
                            ) : (
                              <AccessTimeIcon />
                            )
                          }
                          label={
                            ticketAssignedTo === "ORGANIZATION"
                              ? `Assigned to ${organizationName}`
                              : "Assigned to Thaklis"
                          }
                          size="small"
                          color={
                            ticketAssignedTo === "ORGANIZATION"
                              ? "primary"
                              : "secondary"
                          }
                          variant="outlined"
                          sx={{ height: "24px", minWidth: "150px" }}
                        />
                      </Tooltip>
                    </Box>

                    {canTicketSelfAssign ? (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={ticketAssignedTo === "ORGANIZATION"}
                            onChange={(e) => {
                              const next = e.target.checked
                                ? "ORGANIZATION"
                                : "THAKLIS";
                              setTicketAssignedTo(next);
                              setFieldValue("assignedTo", next);
                            }}
                            color="primary"
                          />
                        }
                        label="Toggle Assignment"
                        labelPlacement="start"
                        sx={{
                          mb: 0,
                          mr: 0,
                          "& .MuiFormControlLabel-label": {
                            fontSize: pxToRem(14),
                          },
                        }}
                      />
                    ) : (
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{ fontSize: pxToRem(13), fontStyle: "italic" }}
                      >
                        No permission to change assignment
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            )}

            {/* Spacer to prevent content from being hidden behind sticky footer */}
            <Box sx={{ height: 120 }} />

            {/* Sticky Footer with Charges and Submit */}
            <Box sx={stickyFooterStyle}>
              {/* Charges Section */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="caption" sx={{ color: '#757575', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Govt Fee
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#424242' }}>
                    AED {Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.govtCharge || 0).toFixed(2)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, borderRight: '1px solid #e0e0e0' }}>
                  <Typography variant="caption" sx={{ color: '#757575', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Service
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#424242' }}>
                    AED {Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.serviceCharge || 0).toFixed(2)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2 }}>
                  <Typography variant="caption" sx={{ color: '#757575', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    VAT
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: 16, color: '#424242' }}>
                    AED {Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.taxOnServiceCharge || 0).toFixed(2)}
                  </Typography>
                </Box>
              </Box>

              {/* Total and Submit Section */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, ml: 'auto' }}>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography variant="caption" sx={{ color: '#757575', fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    Total Amount
                  </Typography>
                  <Typography sx={{ fontWeight: 700, fontSize: 20, color: '#009688' }}>
                    AED {(
                      Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.govtCharge || 0) +
                      Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.serviceCharge || 0) +
                      Number(ticketAssignedTo === "ORGANIZATION" ? 0 : chargeMapping?.taxOnServiceCharge || 0)
                    ).toFixed(2)}
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  onClick={() => navigate(-1)}
                  sx={{
                    minWidth: 100,
                    height: 40,
                    fontSize: 14,
                    fontWeight: 600,
                    textTransform: 'none',
                    borderColor: '#9e9e9e',
                    color: '#616161',
                    '&:hover': {
                      borderColor: '#757575',
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  Cancel
                </Button>
                <WDButton
                  variant="gradient"
                  disabled={!dirty || !isValid || !_isFieldsAreValid()}
                  type="submit"
                  sx={{
                    minWidth: 120,
                    height: 40,
                    fontSize: 14,
                    fontWeight: 600,
                    textTransform: 'none',
                  }}
                >
                  Submit
                </WDButton>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>

    {/* Preview dialog removed - direct submit path */}

    {/* Customer Creation Dialog */}
    <Dialog
      onClose={handleCloseCustomerDialog}
      aria-labelledby="customer-dialog-title"
      maxWidth="md"
      fullWidth
      open={openCustomerDialog}
      disableEscapeKeyDown
    >
      <DialogTitle id="customer-dialog-title" sx={{ bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
        Customer Not Found - Add New Customer
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, p: 2, bgcolor: '#f8f8f8', border: '1px solid #e0e0e0', borderRadius: 1, mb: 2 }}>
          <DialogContentText sx={{ fontWeight: 'bold', color: 'text.primary', display: 'flex', alignItems: 'center' }}>
            Customer UID: <Box component="span" sx={{ ml: 1, p: 0.5, bgcolor: '#e3f2fd', borderRadius: 0.5, fontFamily: 'monospace' }}>{newCustomer.uid}</Box>
          </DialogContentText>
        </Box>
        <DialogContentText sx={{ mb: 2 }}>
          Please enter the customer details below to add them to the system and proceed with ticket creation.
        </DialogContentText>
        <DialogContentText sx={{ mb: 1, color: 'text.primary', fontWeight: 'medium' }}>
          Fields marked with <Box component="span" sx={{ color: 'error.main' }}>*</Box> are required. After adding the customer, you'll be able to continue creating the ticket.
        </DialogContentText>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="firstNameEn"
              label="First Name"
              value={newCustomer.firstNameEn}
              onChange={handleCustomerInputChange}
              fullWidth
              required
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="middleNameEn"
              label="Middle Name"
              value={newCustomer.middleNameEn}
              onChange={handleCustomerInputChange}
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="lastNameEn"
              label="Last Name"
              value={newCustomer.lastNameEn}
              onChange={handleCustomerInputChange}
              fullWidth
              required
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="nameEn"
              label="Full Name"
              value={newCustomer.nameEn}
              onChange={handleCustomerInputChange}
              fullWidth
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="mobileNumber"
              label="Mobile Number"
              value={newCustomer.mobileNumber}
              onChange={handleCustomerInputChange}
              fullWidth
              required
              margin="dense"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              label="Email"
              type="email"
              value={newCustomer.email}
              onChange={handleCustomerInputChange}
              fullWidth
              margin="dense"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <WDButton onClick={handleCloseCustomerDialog} color="secondary">
          Cancel
        </WDButton>
        <WDButton 
          onClick={handleCreateCustomer} 
          variant="gradient" 
          disabled={!newCustomer.firstNameEn || !newCustomer.lastNameEn || !newCustomer.mobileNumber}
        >
          Add Customer
        </WDButton>
      </DialogActions>
    </Dialog>
    
    {/* Quick Add Employee Dialog */}
    <QuickEmployeeAddDialog
      open={openQuickAddEmployee}
      onClose={() => setOpenQuickAddEmployee(false)}
      onEmployeeAdded={handleEmployeeAdded}
    />
  </LayoutCard>
);
};

export default NewTicket;
